import { Country } from "@angular-material-extensions/select-country";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { LetItGoType } from "@core/models/letitgo-type";
import {
  Association,
  BookingFlightReq,
  BookingQuery,
  Company,
  Fares,
  FlightSelectDto,
  MultifamilyRS,
  Penalty,
  PreOrderDto,
  Segment,
  SolutionStandAloneCatalogue,
  TransportSupplement,
  Traveller,
} from "@models";
import { NgbDateParserFormatter, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  AllowService,
  AuthService,
  BookedService,
  CompanyService,
  FlightLleegoService,
  FlightService,
  GoogleMaps,
  NgxToastrService,
  StateService,
  TravelUtilsService,
  UserService,
  UtilsService,
} from "@services";
import { DialogAssignProjectComponent } from "@shared/component/dialog-assign-project/dialog-assign-project.component";
import { SelectFlightResponse } from "@shared/interfaces/amadeus/select/select-flight-response";
import { AppState } from "app/app.reducer";
import { ViewPdfModalComponent } from "app/modules/businessEntities/user/user-detail/view-pdf-modal/view-pdf-modal.component";
import * as moment from "moment";
import { from, ObservableInput, of, Subscription } from "rxjs";
import { catchError, filter, take } from "rxjs/operators";
import swal from "sweetalert2";
import { DialogPoliciesComponent } from "./dialog-policies/dialog-policies.component";
import municipalitiesJson from "../../../../../assets/utils/resident-municipalities.json";
import { UserCardModalComponent } from "@shared/component/user-card-modal/user-card-modal.component";
import { FlightSeatsSelectionComponent } from "./flight-seats-selection/flight-seats-selection.component";
import Swal from "sweetalert2";

@Component({
  selector: "app-select-flight",
  templateUrl: "./select-flight.component.html",
  styleUrls: ["./select-flight.component.scss"],
})
export class SelectFlightComponent implements OnInit, OnDestroy {
  fullFlight: any = {};
  loading = false;
  travelers: any = {};
  isLinear = true;
  detailsRead = false;
  confirmed = false;
  flightIds: number[] = [];
  requestId = "";
  priceTotal = "";
  departureTime: string[] = [];
  arrivalTime: string[] = [];
  segments: any[] = [];
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;
  isEditable = true;
  flightSelectDto: FlightSelectDto;
  loadingFlight = false;
  flightDetails: SelectFlightResponse = {};
  duration: string[] = [];
  imgAirlines: string[] = [];
  totalDuration = "";
  iconAirlines: string[] = [];
  private subcriptions: Subscription[] = [];
  submitDone = false;
  plusBag = false;
  amount = 0;
  arrayTravelers = [];
  arrayDataTravelers = [];
  arrayBagsIncluded = [];
  genderOptions = [
    { value: "MALE", text: "Hombre" },
    { value: "FEMALE", text: "Mujer" },
  ];
  documentTypeOptions = [
    { value: "PASSPORT", text: "Pasaporte" },
    { value: "IDENTITY_CARD", text: "DNI/NIF" },
    { value: "NIE", text: "NIE" },
  ];
  deviceTypeOptions = [
    { value: "MOBILE", text: "Teléfono móvil" },
    { value: "LANDLINE", text: "Teléfono fijo" },
    { value: "FAX", text: "Fax" },
  ];
  date = new Date();
  minDateNgStruct = {
    year: this.date.getFullYear() - 100,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  maxDateNgStruct = {
    year: this.date.getFullYear(),
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  expiryMinnDateNgStruct = {
    year: this.date.getFullYear(),
    month: this.date.getMonth() + 1,
    day: this.date.getDate() + 1,
  };
  expiryMaxDateNgStruct = {
    year: this.date.getFullYear() + 20,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  flightPreOrdered = false;
  flightPreOrderedResponse: any = {};
  readyToConfirm = false;
  issuanceCountry = "";
  birthCountry = "";
  nationality = "";
  userUuid = "";
  showSecondSelector = false;
  showThirdSelector = false;
  showFourthSelector = false;
  user: any = {};
  company: Company;
  data: any = {};
  userFilters: any = null;
  selectedPolicy: any = null;
  travelData: any = {};
  isUser = true;
  department: any;
  selectedFlights: Array<Segment[]>;
  solutionId: string;
  solutionIva: number;
  basePrice: number;
  totalPrice = 0;
  journeysAssociations: Association[];
  isPriceWithinRange: boolean;
  authPriceOverDuration: boolean;
  totalFlightDuration: number = 0;
  isOverDurationLimit: boolean = false;
  lleegoToken: string;
  policiesSolutionPenalties: Penalty[] = [];
  baggagesInfo: SolutionStandAloneCatalogue;
  travelersAge: number[];
  selectedBaggages: TransportSupplement[];
  needAddress = false;
  needDocApis = false;
  emitOnBookingDetail: any;
  availablePayments: any;
  baggagePrice = 0;
  isAdmin = false;
  isEmployee = false;
  canUseTRM: boolean;
  userToBook: string;
  multiFamily: MultifamilyRS;
  optimusMultiFamily: MultifamilyRS;
  @ViewChild("stepper") stepper: MatStepper;
  fareSelected: Fares;
  fareName: string;
  canBaggage = false;
  requestData: any;
  durations: string[] = [];
  selectBaggage = [];
  navigationExtras: NavigationExtras = {
    state: {
      module: "flights",
      fromReservation: true
    },
  };
  extraInfoForm: UntypedFormGroup;
  canUseResident: any;
  residentOptions = [
    { value: "none", text: "Ninguno" },
    { value: "CN", text: "Canarias" },
    { value: "CE", text: "Ceuta" },
    { value: "BL", text: "Baleares" },
    { value: "ML", text: "Melilla" },
  ];
  didSearch: boolean = true;
  munipalitiesList = municipalitiesJson;
  selectedUsers: any;
  projectData: any;
  externalUser: any;
  seatMap: any;
  paramsMap: any;
  priceChanged: any;
  farePricing: any;
  getPriceStep: any;
  private flightSelectedStateBackup: any;
  scalesInfo: any;
  totalTime: any;
  arrivalDate: any;
  expectedAmountSeats = 0;
  selectedSeats;
  pricing: any;
  seatsByPassenger: any;
  accomInfo;
  isPackageRate: string;
  currentStepIndex = 0;
  selectedPriority: TransportSupplement[] = [];
  priorityPrice = 0;
  passengerBookingParams: any = null;
  
  constructor(
    private flightService: FlightService,
    public translate: TranslateService,
    private router: Router,
    private ngxToastrService: NgxToastrService,
    private _formBuilder: UntypedFormBuilder,
    private travelUtilsService: TravelUtilsService,
    private authService: AuthService,
    private userService: UserService,
    public flightLleegoService: FlightLleegoService,
    private dialog: MatDialog,
    private stateService: StateService,
    public utilsService: UtilsService,
    public store: Store<AppState>,
    private modalService: NgbModal,
    private bookedService: BookedService,
    public allowService: AllowService,
    private companyService: CompanyService,
    private activatedRoute: ActivatedRoute,
    private ngbDateParser: NgbDateParserFormatter,
    private googleMaps: GoogleMaps,
  ) {
    this.utilsService.socket.on("create-booking", (result) => {
        this.accomInfo.bookingInfo = this.utilsService.getBookingInfo();
        this.accomInfo.selectedRooms = this.utilsService.getSelectedRooms();
        this.projectData = this.utilsService.getProjectData();
        if(!this.selectedUsers){
          this.selectedUsers = this.utilsService.getSelectedUsers();
        }
        if(!this.accomInfo.hotel){
          this.accomInfo.hotel = this.utilsService.getHotelInfo();
        }

        if (this.utilsService.correlationId.includes(result.correlationId)) {
          this.utilsService.correlationId.splice(this.utilsService.correlationId.indexOf(result.correlationId), 1)
          this.utilsService.loadingHotels = false;
          const user = this.selectedUsers.find(u => u.correlationId === result.correlationId);
          const userUuid = user ? user.uuid : this.accomInfo.uuidUser;
          const checkInAux = moment(
            moment(this.ngbDateParser.format(this.accomInfo.searchConfig.checkIn), "DD/MM/YYYY").toLocaleString()
          ).format("YYYY-MM-DD");
          const checkOutAux = moment(
            moment(this.ngbDateParser.format(this.accomInfo.searchConfig.checkOut), "DD/MM/YYYY").toLocaleString()
          ).format("YYYY-MM-DD");
          if((result.data.type && (result.data.type?.toLowerCase().includes("error") || result.data.type?.toLowerCase().includes("exception"))) || (result.data.bookingStatus && (result.data.bookingStatus?.toLowerCase().includes('unknown') || result.data.bookingStatus?.toLowerCase().includes('error')))) {
            this.translate
            .get([
              "common.congrat",
              "search.search-booked.success-room-booked",
            ])
            .subscribe((response) => {
              Swal.fire({
                position: "center",
                imageUrl:
                  "../../../../../assets/img/svg/check-circle.svg",
                title: response["common.congrat"],
                text: response[
                  "search.search-booked.success-room-booked"
                ],
                showConfirmButton: false,
                timer: 300000000000,
              }).then(() => {
                
                const room = this.accomInfo.bookingInfo.rooms.find((r) => r.correlationId === result.correlationId)
                const params = {
                  rooms: [room],
                  destinationName: this.accomInfo.hotel.address,
                  checkIn: checkInAux,
                  checkOut: checkOutAux,
                  userUuid: userUuid,
                  comments: "",
                  hotelName: this.accomInfo.hotel.name,
                  guests: this.accomInfo.guests,
                };
                if (this.accomInfo.bookingInfo.customCode !== "") {
                  params["customCode"] = this.accomInfo.bookingInfo.customCode;
                }
                if (this.accomInfo.bookingInfo.costCenter !== "") {
                  params["costCenter"] = this.accomInfo.bookingInfo.costCenter;
                }
                params['hotel'] = this.accomInfo.hotel;
                const bookUuid = result?.data?.uuid 
                                  ?? result?.data?.booked?.uuid 
                                  ?? result?.book?.uuid;
                const roomIndex = this.accomInfo.selectedRooms.findIndex(r => r.correlationId === room.correlationId);
                if(bookUuid && this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid !== "none"){
                  this.flightLleegoService.addBookingToTravel({
                    type: 'booking',
                    uuid: bookUuid,
                    initDate: checkInAux,
                    endDate: checkOutAux
                  }, this.projectData);
                }
                this.createBookingFailed(result, room, roomIndex, params, this.accomInfo.bookingInfo, this.accomInfo.canUseTRM, this.accomInfo.selectedRooms, this.accomInfo.hotel, this.accomInfo.searchConfig, this.accomInfo.totalAdults);
              });
            });
          } else {
            this.translate
            .get([
              "common.congrat",
              "search.search-booked.success-room-booked",
            ])
            .subscribe((response) => {
              Swal.fire({
                position: "center",
                imageUrl:
                  "../../../../../assets/img/svg/check-circle.svg",
                title: response["common.congrat"],
                text: response[
                  "search.search-booked.success-room-booked"
                ],
                showConfirmButton: false,
                timer: 3000,
              }).then(() => {
                    //this.onGetPDF(result.data);
                    const bookUuid = result?.data?.uuid 
                                  ?? result?.data?.booked?.uuid 
                                  ?? result?.book?.uuid;
                    if(bookUuid && this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid !== "none"){
                      this.flightLleegoService.addBookingToTravel({
                        type: 'booking',
                        uuid: bookUuid,
                        initDate: checkInAux,
                        endDate: checkOutAux
                      }, this.projectData);
                    }

                    const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
                    if (route) {
                      this.router.navigate([route], { queryParams: { specialAction: true } });
                    }
                  });
                });
              }
            }
          })
    this.subcriptions.push(
      this.store.select("auth").subscribe((s: any) => {
        this.externalUser = s?.user;
        if(s.user && s.user.type?.toUpperCase() === "EMPLOYEE"){
          this.isEmployee = true;
        }
        if (s.user && s.user.type?.toUpperCase() !== "USER" && (s.user.type?.toUpperCase() === "COMPANY" || s.user.type?.toUpperCase() === "EMPLOYEE" ||
          s.user.type?.toUpperCase() === "AGENCY" || s.user.type?.toUpperCase() === "HUB")) {
          this.isAdmin = true;
          this.userToBook = localStorage.getItem("userToBook")
            ? this.utilsService.decrypt(localStorage.getItem("userToBook"))
            : null;
          this.canUseTRM = s.user.type?.toUpperCase() === "EMPLOYEE" ? true : (s.user.type
            ? s.user.plan && s.user.plan.permissions.canUseTRM
            : s.user.user.plan && s.user.user.plan.permissions.canUseTRM);
          if (!this.canUseTRM) {
            this.canUseTRM = this.authService.userCompanyPlan?.permissions.canUseTRM;
          }
        }
      })
    );
    if (this.utilsService.isBackNavigation()) {
      this.utilsService.setBackNavigation(false);
      this.router.navigate(['/flight']);
    } else {
      const navigation = this.router.getCurrentNavigation();
      const savedStateString = localStorage.getItem('stateFlightRedirect');
      if (navigation && navigation.extras.state) {
        this.userUuid = navigation.extras.state.userUuid;
        this.isUser = navigation.extras.state.isUser;
        this.selectedFlights = navigation.extras.state.selectedFlights;
        this.selectedUsers = navigation.extras.state.selectedUsers;
        this.projectData = navigation.extras.state.projectData;
        this.solutionId = navigation.extras.state.solutionId;
        this.solutionIva = navigation.extras.state.solutionIva;
        this.journeysAssociations = navigation.extras.state.journeysAssociations;
        this.lleegoToken = navigation.extras.state.lleegoToken;
        this.travelersAge = navigation.extras.state.travelersAge;
        this.multiFamily = navigation.extras.state.multiFamilyRes;
        this.optimusMultiFamily = this.multiFamily;
        this.durations = navigation.extras.state.duration;
        this.travelersAge = navigation.extras.state.travelersAge;
        this.isPriceWithinRange = navigation.extras.state.isPriceWithinRange;
        this.authPriceOverDuration = navigation.extras.state.authPriceOverDuration;
        this.totalFlightDuration = navigation.extras.state.totalFlightDuration;
        this.scalesInfo = navigation.extras.state.scalesInfo;
        this.totalTime = navigation.extras.state.totalTime;
        this.arrivalDate = navigation.extras.state.arrivalDate;
        this.selectedPolicy = navigation.extras.state.selectedPolicy ?? null;
        this.userFilters =
          navigation.extras.state.userFilters
          ?? navigation.extras.state.selectedPolicy?.filters
          ?? {};
      } else if (savedStateString) {
        const savedState = JSON.parse(savedStateString);
        this.userUuid = savedState.userUuid;
        this.isUser = savedState.isUser;
        this.selectedFlights = savedState.selectedFlights;
        this.selectedUsers = savedState.selectedUsers;
        this.projectData = savedState.projectData;
        this.solutionId = savedState.solutionId;
        this.solutionIva = savedState.solutionIva;
        this.journeysAssociations = savedState.journeysAssociations;
        this.lleegoToken = savedState.lleegoToken;
        this.travelersAge = savedState.travelersAge;
        this.multiFamily = savedState.multiFamilyRes;
        this.optimusMultiFamily = savedState.multiFamily;
        this.durations = savedState.durations;
        this.isPriceWithinRange = savedState.isPriceWithinRange;
        this.authPriceOverDuration = savedState.authPriceOverDuration;
        this.totalFlightDuration = savedState.totalFlightDuration;
        this.scalesInfo = navigation.extras.state.scalesInfo || savedState.scalesInfo;
        this.totalTime = navigation.extras.state.totalTime || savedState.totalTime;
        this.arrivalDate = navigation.extras.state.arrivalDate || savedState.arrivalDate;
        this.selectedPolicy = savedState.selectedPolicy ?? null;
        this.userFilters = savedState.userFilters ?? savedState.selectedPolicy?.filters ?? {};


        const restoredForm = this._formBuilder.group(savedState.flightSearchFormData);
        this.stateService.setFlightSearch(restoredForm);
        this.stateService.totalPrice = savedState.stateTotalPrice;
        this.stateService.flightTravelers = savedState.stateFlightTravelers;
        this.stateService.transportId = savedState.stateTransportId;

        localStorage.removeItem('stateFlightRedirect');
      } else {
        this.router.navigate(['/flight']);
      }
    }
    const accom = localStorage.getItem('packageRateAccomInfo')
    if (accom) {
      this.accomInfo = JSON.parse(accom)
    }
  }

  ngOnInit() {
    this.isPackageRate = localStorage.getItem("isPackageRate")
    this.stateService.didFirstSearch = true;
    this.loadingFlight = true;
    this.extraInfoForm = this._formBuilder.group({
      customCode: [null],
      costCenter: [null],
      travellerReason: [null],
      annotationsExtras: [null],
    });
    this.requestData = {
      token: this.lleegoToken,
      solutionID0: this.solutionId,
      journey00: this.journeysAssociations[0]?.journey_references[0],
      journey01: this.journeysAssociations[1]?.journey_references[0],
      userUuid: this.userUuid,
      passengers: this.travelersAge.length
    };
    this.firstFormGroup = this._formBuilder.group({});
    this.secondFormGroup = this._formBuilder.group({
      dateOfBirth: ["", [Validators.required]],
      gender: [""],
      firstName: ["", [Validators.required, Validators.maxLength(90)]],
      lastName: ["", [Validators.required, Validators.maxLength(90)]],
      documentType: [""],
      documentNumber: ["", [Validators.required]],
      issuanceDate: [""],
      expiryDate: [""],
      issuanceLocation: [""],
      birthPlace: [""],
      deviceType: [""],
      phoneNumber: ["", [Validators.minLength(9), Validators.required]],
      companyName: ["", [Validators.required, Validators.maxLength(20)]],
      emailAddress: ["", [Validators.required, Validators.email]],
    });
    this.thirdFormGroup = this._formBuilder.group({});

    if (this.isUser) {
      this.subcriptions.push(
        this.authService.getProfile().subscribe((u) => {
          this.user = u;
          this.canUseResident = this.user.resident && this.user.resident.toString() !== "none" && this.stateService.residentCandidates && this.stateService.residentCandidates.find(r => r === this.user.resident);
          this.userUuid = u.uuid;
          this.subcriptions.push(
            this.userService
              .getPoliciesUser(this.user["uuid"])
              .subscribe((policy) => {
                const hasNavFilters = this.userFilters && Object.keys(this.userFilters).length > 0;
                if (!hasNavFilters) {
                  this.userFilters = policy?.filters ?? {};
                  this.selectedPolicy = policy;
                }
              })
          );
          if (this.user?.companyUuid) {
            this.companyService.getCompany(this.user.companyUuid).subscribe(
              (company: Company) => {
                this.company = company;
              },
              (error) => { }
            );
          }
        })
      );
    } else {
      this.subcriptions.push(
        this.userService.getUser(this.userUuid).subscribe((u) => {
          this.user = u;
          this.canUseResident = this.user.resident && this.user.resident.toString() !== "none" && this.stateService.residentCandidates && this.stateService.residentCandidates.find(r => r === this.user.resident);
          this.subcriptions.push(
            this.userService
              .getPoliciesUser(this.user["uuid"])
              .subscribe((policy) => {
                // this.groupRestriction = group;
                const hasNavFilters = this.userFilters && Object.keys(this.userFilters).length > 0;

                if (!hasNavFilters) {
                  this.userFilters = policy?.filters ?? {};
                  this.selectedPolicy = policy;
                }
              })
          );
          if (this.user?.companyUuid) {
            this.companyService.getCompany(this.user.companyUuid).subscribe(
              (company: Company) => {
                this.company = company;
              },
              error => { }
            );
          }
        })
      );
    }
    this.isAdmin = this.isUser === true ? false : true;

    const params = { ...this.activatedRoute.snapshot.queryParams };
    const Ds_SignatureVersion = params['Ds_SignatureVersion'];
    const Ds_MerchantParameters = params['Ds_MerchantParameters'];
    const Ds_Signature = params['Ds_Signature'];

    if (Ds_SignatureVersion && Ds_MerchantParameters && Ds_Signature) {
      const redsysData = {
        Ds_SignatureVersion,
        Ds_MerchantParameters,
        Ds_Signature,
      };

      const cardName = localStorage.getItem('cardName');
      if (cardName) {
        redsysData['cardName'] = cardName;
        localStorage.removeItem('cardName');
      }

      const uuidToBook = this.userToBook ? this.userToBook : this.userUuid;
      this.userService
        .postUserNewTokenRedsys(uuidToBook, redsysData)
        .subscribe(
          (result) => {
            this.user = result;
            this.translate.get("company.card.card-added").subscribe((resp) => {
              this.ngxToastrService.typeSuccess(null, resp);
            });
          },
          (err) => {
            this.translate.get("company.card.error").subscribe((resp) => {
              this.ngxToastrService.typeInfo(null, resp);
            });
          }
        );
    }
  }

  // get campos del formulario
  get phoneNumber() {
    return this.secondFormGroup.get("phoneNumber");
  }

  get firstName() {
    return this.secondFormGroup.get("firstName");
  }
  get lastName() {
    return this.secondFormGroup.get("lastName");
  }
  get email() {
    return this.secondFormGroup.get("emailAddress");
  }
  get documentNumber() {
    return this.secondFormGroup.get("documentNumber");
  }
  get dateOfBirth() {
    return this.secondFormGroup.get("dateOfBirth");
  }
  get issuanceDate() {
    return this.secondFormGroup.get("issuanceDate");
  }
  get expiryDate() {
    return this.secondFormGroup.get("expiryDate");
  }
  get gender() {
    return this.secondFormGroup.get("gender");
  }
  get companyName() {
    return this.secondFormGroup.get("companyName");
  }
  // fin get campos del formulario

  getLogo(value) {
    return `assets/img/airlines/small/${value}.png`;
  }

  getTime(value: string) {
    const res = value.split("T")[1].slice(0, 5);
    return res;
  }

  getDuration(segment: Segment) {
    const departureDate = moment(segment.object.departure_date);
    const arrivalDate = moment(segment.object.arrival_date);
    const duration = moment.duration(departureDate.diff(arrivalDate));
    return duration.toISOString().split("PT")[1];
  }

  fillArrayTravelers(id: string, i, option, none?) {
    this.arrayTravelers.forEach((t) => {
      if (t.id === id) {
        if (none) {
          delete t.withExtraBag;
        } else {
          t.withExtraBag = {
            bagTypeId: option.id,
            count: i + 1,
          };
        }
      }
    });
  }
  
  fillArrayIncludedBagsInit(included: any) {
    Object.keys(included.bags).map((k) => {
      this.arrayBagsIncluded.push({ id: k, data: included.bags[k] });
    });
  }

  loadIdentificationData(event) {
    let passportExpires = "";
    let passportIssuanceDate = "";
    let dniIssuanceDate = "";
    let dniExpirationDate = "";
    if (this.arrayDataTravelers.length === 0) {
      if (event === "0: PASSPORT") {
        if (
          this.user &&
          this.user["passportExpires"] &&
          this.user["passportExpires"] !== "" &&
          this.user["passportExpires"] !== null
        ) {
          passportExpires = moment(
            this.user["passportExpires"].split("T")[0]
          ).format("YYYY-MM-DD");
          this.secondFormGroup.controls["expiryDate"].setValue(
            this.user
              ? this.user["passportExpires"]
                ? {
                  year: parseInt(passportExpires.split("-")[0], 10),
                  month: parseInt(passportExpires.split("-")[1], 10),
                  day: parseInt(passportExpires.split("-")[2], 10),
                }
                : null
              : null
          );
        }
        if (
          this.user &&
          this.user["passportIssuanceDate"] &&
          this.user["passportIssuanceDate"] !== "" &&
          this.user["passportIssuanceDate"] !== null
        ) {
          passportIssuanceDate = moment(
            this.user["passportIssuanceDate"].split("T")[0]
          ).format("YYYY-MM-DD");
          this.secondFormGroup.controls["issuanceDate"].setValue(
            this.user
              ? this.user["passportIssuanceDate"]
                ? {
                  year: parseInt(passportIssuanceDate.split("-")[0], 10),
                  month: parseInt(passportIssuanceDate.split("-")[1], 10),
                  day: parseInt(passportIssuanceDate.split("-")[2], 10),
                }
                : null
              : null
          );
        }
      } else {
        if (
          this.user &&
          this.user["dniIssuanceDate"] &&
          this.user["dniIssuanceDate"] !== "" &&
          this.user["dniIssuanceDate"] !== null
        ) {
          dniIssuanceDate = moment(
            this.user["dniIssuanceDate"].split("T")[0]
          ).format("YYYY-MM-DD");
          this.secondFormGroup.controls["issuanceDate"].setValue(
            this.user
              ? this.user["dniIssuanceDate"]
                ? {
                  year: parseInt(dniIssuanceDate.split("-")[0], 10),
                  month: parseInt(dniIssuanceDate.split("-")[1], 10),
                  day: parseInt(dniIssuanceDate.split("-")[2], 10),
                }
                : null
              : null
          );
        }
        if (
          this.user &&
          this.user["dniExpirationDate"] &&
          this.user["dniExpirationDate"] !== "" &&
          this.user["dniExpirationDate"] !== null
        ) {
          dniExpirationDate = moment(
            this.user["dniExpirationDate"].split("T")[0]
          ).format("YYYY-MM-DD");
          this.secondFormGroup.controls["expiryDate"].setValue(
            this.user
              ? this.user["dniExpirationDate"]
                ? {
                  year: parseInt(dniExpirationDate.split("-")[0], 10),
                  month: parseInt(dniExpirationDate.split("-")[1], 10),
                  day: parseInt(dniExpirationDate.split("-")[2], 10),
                }
                : null
              : null
          );
        }
      }
    }
  }

  preOrderFlight() {
    this.loadingFlight = true;
    const arrayIds = [];
    this.flightIds.forEach((e) => {
      arrayIds.push(e.toString());
    });
    const dto: PreOrderDto = {
      requestId: this.requestId,
      flights: arrayIds,
      travelers: this.arrayTravelers,
    };
    if (this.userUuid !== "") {
      dto.userUuid = this.userUuid;
    }
    let birthdate = "";
    let dniIssuanceDate = "";
    let dniExpirationDate = "";
    if (
      this.user &&
      this.user["birthdate"] &&
      this.user["birthdate"] !== "" &&
      this.user["birthdate"] !== null
    ) {
      birthdate = moment(this.user["birthdate"].split("T")[0]).format(
        "YYYY-MM-DD"
      );
    }
    this.subcriptions.push(
      this.flightService.preOrderFlight(dto).subscribe(
        (result) => {
          this.flightPreOrderedResponse = result;
          this.loadingFlight = false;
          this.flightPreOrdered = true;
          this.secondFormGroup.controls["firstName"].setValue(
            this.user["name"]
          );
          this.secondFormGroup.controls["lastName"].setValue(
            this.user["lastname"]
          );
          this.secondFormGroup.controls["documentType"].setValue(
            "IDENTITY_CARD"
          );
          this.secondFormGroup.controls["documentNumber"].setValue(
            this.user["dni"]
          );
          this.secondFormGroup.controls["dateOfBirth"].setValue(
            this.user
              ? this.user["birthdate"]
                ? {
                  year: parseInt(birthdate.split("-")[0], 10),
                  month: parseInt(birthdate.split("-")[1], 10),
                  day: parseInt(birthdate.split("-")[2], 10),
                }
                : null
              : null
          );
          this.secondFormGroup.controls["gender"].setValue(
            this.user["gender"].toString()?.toUpperCase()
          );
          this.secondFormGroup.controls["emailAddress"].setValue(
            this.user["email"]
          );
          if (
            this.user &&
            this.user["dniIssuanceDate"] &&
            this.user["dniIssuanceDate"] !== "" &&
            this.user["dniIssuanceDate"] !== null
          ) {
            dniIssuanceDate = moment(
              this.user["dniIssuanceDate"].split("T")[0]
            ).format("YYYY-MM-DD");
            this.secondFormGroup.controls["issuanceDate"].setValue(
              this.user
                ? this.user["dniIssuanceDate"]
                  ? {
                    year: parseInt(dniIssuanceDate.split("-")[0], 10),
                    month: parseInt(dniIssuanceDate.split("-")[1], 10),
                    day: parseInt(dniIssuanceDate.split("-")[2], 10),
                  }
                  : null
                : null
            );
          }
          if (
            this.user &&
            this.user["dniExpirationDate"] &&
            this.user["dniExpirationDate"] !== "" &&
            this.user["dniExpirationDate"] !== null
          ) {
            dniExpirationDate = moment(
              this.user["dniExpirationDate"].split("T")[0]
            ).format("YYYY-MM-DD");
            this.secondFormGroup.controls["expiryDate"].setValue(
              this.user
                ? this.user["dniExpirationDate"]
                  ? {
                    year: parseInt(dniExpirationDate.split("-")[0], 10),
                    month: parseInt(dniExpirationDate.split("-")[1], 10),
                    day: parseInt(dniExpirationDate.split("-")[2], 10),
                  }
                  : null
                : null
            );
          }
        },
        () => {
          this.loadingFlight = false;
          this.travelUtilsService.removeTravelLocalStorage();
          swal.close();
          this.translate.get("flight.form-flight.error").subscribe((resp) => {
            this.ngxToastrService.typeInfo(resp, "");
            this.router.navigateByUrl("flight");
          });
        }
      )
    );
  }

  handleCountry(field: string, event: Country) {
    if (field === "issuanceCountry") {
      this.issuanceCountry = event.alpha2Code;
      this.showSecondSelector = true;
    } else if (field === "nationality") {
      this.nationality = event.alpha2Code;
      this.showThirdSelector = true;
    } else {
      this.birthCountry = event.alpha2Code;
      this.showFourthSelector = true;
    }
  }

  addToList() {
    const idT = this.arrayDataTravelers.length + 1;
    const expiryDate = this.secondFormGroup.controls["expiryDate"].value;
    const issuanceDate = this.secondFormGroup.controls["issuanceDate"].value;
    const dateOfBirth = this.secondFormGroup.controls["dateOfBirth"].value;
    const firstName = this.secondFormGroup.controls["firstName"].value;
    const lastName = this.secondFormGroup.controls["lastName"].value;
    const phone: string = this.secondFormGroup.value.phoneNumber;
    this.arrayDataTravelers.push({
      id: idT.toString(),
      dateOfBirth:
        JSON.stringify(dateOfBirth.month).length === 1
          ? new Date(
            dateOfBirth.year +
            "-" +
            "0" +
            dateOfBirth.month +
            "-" +
            dateOfBirth.day
          )
            .toISOString()
            .split("T")[0]
          : new Date(
            dateOfBirth.year + "-" + dateOfBirth.month + "-" + dateOfBirth.day
          )
            .toISOString()
            .split("T")[0],
      gender: this.secondFormGroup.controls["gender"].value,
      name: {
        firstName: firstName.split(" ")[0],
        middleName: firstName.split(" ")[1] ? firstName.split(" ")[1] : "",
        lastName: lastName.split(" ")[0],
        secondLastName: lastName.split(" ")[1] ? lastName.split(" ")[1] : "",
      },
      documents: [
        {
          documentType: this.secondFormGroup.controls["documentType"].value,
          number: this.secondFormGroup.controls["documentNumber"].value,
          issuanceDate:
            JSON.stringify(issuanceDate.month).length === 1
              ? new Date(
                issuanceDate.year +
                "-" +
                "0" +
                issuanceDate.month +
                "-" +
                issuanceDate.day
              )
                .toISOString()
                .split("T")[0]
              : new Date(
                issuanceDate.year +
                "-" +
                issuanceDate.month +
                "-" +
                issuanceDate.day
              )
                .toISOString()
                .split("T")[0],
          expiryDate:
            JSON.stringify(expiryDate.month).length === 1
              ? new Date(
                expiryDate.year +
                "-" +
                "0" +
                expiryDate.month +
                "-" +
                expiryDate.day
              )
                .toISOString()
                .split("T")[0]
              : new Date(
                expiryDate.year +
                "-" +
                expiryDate.month +
                "-" +
                expiryDate.day
              )
                .toISOString()
                .split("T")[0],
          issuanceCountry: this.issuanceCountry,
          // issuanceLocation: this.secondFormGroup.controls["issuanceLocation"]
          //   .value,
          nationality: this.nationality,
          birthPlace: this.secondFormGroup.controls["birthPlace"].value,
          birthCountry: this.birthCountry,
          holder: true,
        },
      ],
      contact: {
        phones: [
          {
            deviceType: this.secondFormGroup.controls["deviceType"].value
              ? this.secondFormGroup.controls["deviceType"].value
              : "",
            countryCallingCode: phone
              ? phone.length <= 10
                ? phone.substr(0, 2).split("+")[1]
                : phone.substr(0, 3).split("+")[1]
              : "",
            number: phone
              ? phone.length <= 10
                ? phone.substr(2, phone.length)
                : phone.substr(3, phone.length)
              : "",
          },
        ],
        companyName: this.secondFormGroup.controls["companyName"].value,
        emailAddress: this.secondFormGroup.controls["emailAddress"].value,
      },
    });
    if (this.arrayDataTravelers.length > 0) {
      this.secondFormGroup.controls["deviceType"].clearValidators();
      this.secondFormGroup.controls["companyName"].clearValidators();
      this.secondFormGroup.controls["phoneNumber"].clearValidators();
      if (this.arrayDataTravelers.length > 1) {
        const contact = this.arrayDataTravelers[0]["contact"];
        this.arrayDataTravelers.forEach((t) => {
          t["contact"] = contact;
        });
      }
    } else {
      this.secondFormGroup.controls["deviceType"].setValidators(
        Validators.required
      );
      this.secondFormGroup.controls["companyName"].setValidators(
        Validators.required
      );
      this.secondFormGroup.controls["phoneNumber"].setValidators(
        Validators.required
      );
    }
    this.secondFormGroup.reset();
  }

  changeConfirm(value: string) {
    if (value === "Y") {
      this.readyToConfirm = true;
    } else {
      this.readyToConfirm = false;
    }
  }

  getVyooPricePerTraveller(
    travellerData: any,
    seatsByPassenger?: { [uuid: string]: { total: number } }
  ): { [uuid: string]: { individualPrice: number, baggagesPrice: number, priorityPrice: number, seatsPrice: number } } {
    
    const basePrice = this.farePricing
      ? parseFloat(this.farePricing.total)
      : this.totalPrice;

    const numTravellers = travellerData.length || 1;

    const basePricePerTraveller = basePrice / numTravellers;
    const pricesPerTraveller: { [uuid: string]: { individualPrice: number, baggagesPrice: number, priorityPrice: number, seatsPrice: number } } = {};

    travellerData.forEach((traveller, index) => {
      let baggagesPrice = 0;
      const travellerBaggages = this.selectedBaggages.filter(
        baggage => baggage.pax_index?.includes(index)
      );
      for (const baggage of travellerBaggages) {
        baggagesPrice += baggage.total;
      }

      const seatsPrice = seatsByPassenger?.[traveller.uuid]?.total ?? 0;

      let priorityPrice = 0;

      for (const p of (this.selectedPriority || [])) {
        const paxIndexes: number[] = Array.isArray(p?.pax_index)
          ? p.pax_index.map((n: any) => Number(n)).filter((n: number) => !isNaN(n))
          : [];

        if (!paxIndexes.length) continue;

        const affectsThisTraveller = paxIndexes.includes(index);
        if (!affectsThisTraveller) continue;

        priorityPrice += Number(p?.total || 0);
      }

      const individualPrice = basePricePerTraveller + baggagesPrice + priorityPrice + seatsPrice;
      pricesPerTraveller[traveller.uuid] = {
        individualPrice: parseFloat(individualPrice.toFixed(2)),
        baggagesPrice: parseFloat(baggagesPrice.toFixed(2)),
        priorityPrice: parseFloat(priorityPrice.toFixed(2)),
        seatsPrice: parseFloat(seatsPrice.toFixed(2))
      };
    });
    return pricesPerTraveller;
  }
  
  confirmFlight() {
    const vyooPrice = this.priceChanged ? this.priceChanged : this.flightLleegoService.getVyooPrice(this.farePricing, this.totalPrice, this.canUseResident, this.selectedBaggages, this.selectedPriority);
    const travellerData: Traveller[] = this.flightLleegoService.createTravellersData(this.user);
    const priceMap = this.getVyooPricePerTraveller(
      travellerData,
      this.seatsByPassenger ? this.seatsByPassenger : undefined
    );
    
    this.showPaymentCardSelector().then((selectedCard) => {
      if (!selectedCard && !this.company.bookedWithoutCard) {
        return;
      }

    this.flightSelectedStateBackup = JSON.parse(JSON.stringify(this.stateService.flightSelectedState));
    this.utilsService.loadingFlights = true;
    const airlines = [];
    const bookingQuery: BookingQuery = {
      token: this.lleegoToken,
      solutions: [
        {
          id: this.stateService.transportId ? this.stateService.transportId : (this.fareSelected ? this.fareSelected.id : this.solutionId),
          journeys: this.fareSelected
            ? this.fareSelected.journeys_ids
            : [this.journeysAssociations[0]?.journey_references[0]],
        },
      ],
      holder: {
        name: "VYOOTRIP",
        surnames: ["S L"],
        contact: {
          type: "Emergency",
          mails: ["reservas@vyootrip.com"],
          phones: [{
            country_pref: "34",
            number: "648200516",
          }],
          address: "C. Egido, 2",
          city: "Los Villares",
          postal_code: "23160",
          country: "ES",
        }
      },
      travellers: travellerData,
      vyooPrice: vyooPrice,
      vyooPriceMap: priceMap,
      solutionIva: this.solutionIva
    };
    const travel = this.travelUtilsService.getTravelLocalStorage();
    const priorityNormalized = this.normalizePriorityForBooking(this.selectedPriority);

    const ancillaries = [
      ...(this.selectedBaggages || []),
      ...priorityNormalized,
    ].filter(a => a?.id != null);

    if (ancillaries.length > 0) bookingQuery.ancillaries = ancillaries;

    const confirmDto: BookingFlightReq = {
      query: bookingQuery,
      emitOnBookingDetail: this.emitOnBookingDetail,
      available_payments: this.availablePayments
    };
    if (this.userUuid !== "") {
      confirmDto.userUuid = this.userUuid;
    }
    if (travel && travel.data.title) {
      confirmDto["travelName"] = travel.data.title;
    }
    confirmDto["from"] = this.stateService.flightSearchForm.controls[
      "origin"
    ].value
      .split("/")[1]
      .split(" (")[0];
    confirmDto["to"] = this.stateService.flightSearchForm.controls[
      "destination"
    ].value
      .split("/")[1]
      .split(" (")[0];
    const flights: any = this.selectedFlights;
    confirmDto["departureDate"] = flights[0][0].object.departure_date;
    if (flights[1]) {
      confirmDto["returnDate"] = flights[1][0]?.object.departure_date;
    }
    confirmDto["scales"] = this.scalesInfo;
    confirmDto["totalTime"] = this.totalTime;
    confirmDto["arrivalDate"] = this.arrivalDate;
    confirmDto["customCode"] = this.extraInfoForm.value.customCode;
    confirmDto["costCenter"] = this.extraInfoForm.value.costCenter;
    confirmDto["annotationsExtras"] = this.extraInfoForm.value.annotationsExtras;
    if(this.farePricing.amount){
      confirmDto["wholesalePrice"] = this.farePricing.amount;
    }

    if (this.fareName && this.fareSelected) {
      bookingQuery["fares"] = { fareName: this.fareName, fareConditions: this.fareSelected.services ?? [], price: Number(this.fareSelected.total).toFixed(2) }
    }

    if (this.selectedFlights.length > 0) {
      const outwardAirline = this.selectedFlights[0][0].object.marketing_company;
      airlines.push(outwardAirline);
    }

    if (this.selectedFlights.length > 1) {
      const returnAirline = this.selectedFlights[1][0].object.marketing_company;
      airlines.push(returnAirline);
    }

    bookingQuery["airlines"] = airlines;

    if(!this.company.bookedWithoutCard){
      confirmDto["paymentCard"] = {
        name: selectedCard.name,
        token: selectedCard.token
      };
    }

    let seatSelection$ = this.emitOnBookingDetail.emit_on_booking && !this.selectedSeats
    ? from(this.preSelectSeats()).pipe(
        catchError((error) => {
          return of(null);
        })) : of(null);

        seatSelection$
          .subscribe((seatSelectionData) => {
              this.utilsService.loadingFlights = true;
              const selectedSeats = seatSelectionData?.selectedSeats ?? this.selectedSeats;
              const expectedAmount = seatSelectionData?.expectedAmount ?? this.expectedAmountSeats;
              const seatsByPassenger = seatSelectionData?.seatsByPassenger ?? this.seatsByPassenger;
              const requiresAuth    = !!seatSelectionData?.requiresAuth;

              if (selectedSeats?.length && seatsByPassenger) {
                bookingQuery["seats"] = selectedSeats;
                confirmDto["expectedAmount"] = expectedAmount;

                if (expectedAmount && typeof expectedAmount === 'number' && !this.priceChanged) {
                  bookingQuery.vyooPrice = Number(bookingQuery.vyooPrice || 0) + expectedAmount;
                } else if (this.priceChanged) {
                    bookingQuery.vyooPrice = Number(this.priceChanged);
                }
                  bookingQuery.vyooPriceMap = this.getVyooPricePerTraveller(
                    travellerData,
                    seatsByPassenger
                  );

                if (requiresAuth && !this.isAdmin) {
                  this.requestFlight();
                  return of(null);
                }
                if (this.isOverDurationLimit && !this.isAdmin) {
                  this.requestFlight();
                  return of(null);
                }
              }
              if (this.isPackageRate && this.isPackageRate == 'flight') {
                localStorage.setItem('packageRateFlightInfo', JSON.stringify({
                  baggagesNumber: this.getBaggagesNumber(), 
                  bookingQuery,
                  canUseResident: this.canUseResident,
                  canUseTRM: this.canUseTRM,
                  expectedAmountSeats: this.expectedAmountSeats,
                  externalUser: this.externalUser,
                  extraInfoForm: this.extraInfoForm.getRawValue(),
                  fareName: this.fareName,
                  farePricing: this.farePricing,
                  fareSelected: this.fareSelected,
                  flightRequest: confirmDto,
                  flightSelectedStateBackup: this.flightSelectedStateBackup,
                  isAuthorization: false,
                  isOverDurationLimit: this.isOverDurationLimit,
                  isPriceWithinRange: this.isPriceWithinRangeMethod(this.getPriceStep),
                  navigationExtras: this.navigationExtras,
                  priceChanged: this.priceChanged,
                  projectData: this.projectData,
                  residentOptions: this.residentOptions,
                  selectBaggage: this.selectBaggage,
                  selectedBaggages: this.selectedBaggages,
                  selectedPriority: this.selectedPriority,
                  selectedFlights: this.selectedFlights,
                  selectedSeats: this.selectedSeats,
                  totalBaggagePrice: this.getTotalBaggagePrice(),
                  priorityPrice: this.getTotalPriorityPrice(),
                  totalPrice: this.totalPrice,
                  travelersAge: this.travelersAge,
                  user: this.user,
                  userUuid: this.userUuid,
                }))
                if (this.isAdmin) localStorage.setItem("userToBook", this.utilsService.encrypt(this.userUuid));
                this.router.navigate([`search/${this.userUuid}`])
                this.utilsService.loadingFlights = false;
                of(null);
              } else {
                const isPack = !!this.accomInfo;

                const finalizePack = () => {
                  if (!isPack) return;

                  this.doBooking(
                    this.accomInfo.searchConfig,
                    this.accomInfo.bookingInfo,
                    this.accomInfo.hotel,
                    this.accomInfo.selectedTravelers,
                    this.accomInfo.uuidUser,
                    this.accomInfo.guests,
                    this.accomInfo.company,
                    this.accomInfo.selectedCard,
                    this.accomInfo.isEmployee,
                    this.accomInfo.isAdmin,
                    this.accomInfo.canRequest,
                    this.accomInfo.userFilter,
                    this.accomInfo.canOnlyRequestRooms,
                    this.accomInfo.selectedUsers,
                    this.accomInfo.projectData,
                    this.accomInfo.selectedRooms,
                    this.accomInfo.canUseTRM,
                    this.accomInfo.totalAdults,
                    this.accomInfo.selectedOccupancy,
                    this.accomInfo.externalUser,
                    this.accomInfo.isUser
                  );

                  localStorage.removeItem('packageRateAccomInfo');
                  localStorage.removeItem('isPackageRate');
                };

                this.flightLleegoService.doFlightBooking(
                  confirmDto,
                  this.projectData,
                  bookingQuery,
                  this.fareSelected,
                  this.expectedAmountSeats,
                  this.priorityPrice,
                  this.getTotalBaggagePrice(),
                  this.priceChanged,
                  this.navigationExtras,
                  this.externalUser,
                  this.canUseTRM,
                  this.user,
                  this.selectedFlights,
                  this.travelersAge,
                  this.flightSelectedStateBackup,
                  this.farePricing,
                  this.totalPrice,
                  this.canUseResident,
                  this.selectedBaggages,
                  this.selectedPriority,
                  this.extraInfoForm,
                  this.fareName,
                  this.residentOptions,
                  this.userUuid,
                  this.isPackageRate,
                  {
                    onSuccess: finalizePack,
                    onLetItGo: finalizePack,
                    onAvailOut: () => {
                      this.flightLleegoService.goBack(true);
                    }
                  }
                );
              }
            }), filter((result) => result !== null)
          
     })
  }

  showPaymentCardSelector(): Promise<any> {
    if (this.company.bookedWithoutCard) {
      return Promise.resolve(null);
    }

    if (!Array.isArray(this.user.paymentCards)) {
      this.user.paymentCards = this.user.paymentCards ? [this.user.paymentCards] : [];
    }

    /* if (!Array.isArray(this.user.personalPaymentCards)) {
      this.user.personalPaymentCards = this.user.personalPaymentCards ? [this.user.personalPaymentCards] : [];
    } */

    this.user.paymentCards = this.user.paymentCards.filter(c => c?.token);
    const defaultToken = this.company?.cardRedsys?.find(c => c?.isDefault && c?.token)?.token || null;

    if (defaultToken) {
      this.user.paymentCards = [
        ...this.user.paymentCards.filter(c => c.token === defaultToken),
        ...this.user.paymentCards.filter(c => c.token !== defaultToken),
      ];
    }

    const stateData = {
      userUuid: this.userUuid,
      isUser: this.isUser,
      selectedFlights: this.selectedFlights,
      selectedUsers: this.selectedUsers,
      projectData: this.projectData,
      solutionId: this.solutionId,
      solutionIva: this.solutionIva,
      journeysAssociations: this.journeysAssociations,
      lleegoToken: this.lleegoToken,
      travelersAge: this.travelersAge,
      multiFamily: this.multiFamily,
      optimusMultiFamily: this.optimusMultiFamily,
      durations: this.durations,
      flightSearchFormData: this.stateService.flightSearchForm.getRawValue(),
      stateTotalPrice: this.stateService.totalPrice,
      stateFlightTravelers: this.stateService.flightTravelers,
      stateTransportId: this.stateService.transportId,
      isPriceWithinRange: this.isPriceWithinRange,
      authPriceOverDuration: this.authPriceOverDuration,
      scalesInfo: this.scalesInfo,
      totalTime: this.totalTime,
      arrivalDate: this.arrivalDate,
      selectedPolicy: this.selectedPolicy,
      userFilters: this.userFilters,
    };
    localStorage.setItem('stateFlightRedirect', JSON.stringify(stateData));

    return new Promise((resolve) => {
      const modalRef = this.modalService.open(UserCardModalComponent, {
        windowClass: 'custom-modal-user-card',
        centered: true,
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.bookCards = this.user.paymentCards;
      /* modalRef.componentInstance.bookPersonalCards = this.user.personalPaymentCards; */
      modalRef.componentInstance.fromBookSelect = true;
      modalRef.componentInstance.bookType = 'flight';
      modalRef.componentInstance.user = this.user;
      modalRef.componentInstance.cardSelected.subscribe((selectedCard) => {
        resolve(selectedCard);
      });
      modalRef.result.catch(() => {
        resolve(null);
      });
    });
  }

  emitFlight(lleegoBookingID?, locator?, paymentId?, price?, ancillaries?, available_payments?) {
    this.utilsService.loadingFlights = true;
    const data = {
      params: {
        locator: locator,
        payment: paymentId,
        userUuid: this.userUuid,
      },
      body: {
        query: {
          token: this.lleegoToken,
          available_payments,
          // expected_amount: expected_amount
        },
      },
    };
    if (!this.emitOnBookingDetail.emit_on_booking) {
      this.flightLleegoService.putFlightEmit(lleegoBookingID, data).subscribe(
        (res2) => {
          this.utilsService.loadingFlights = false;
          this.flightLleegoService.redirectToInit(this.externalUser, this.canUseTRM, this.navigationExtras);
        },
        (err) => {
          this.utilsService.loadingFlights = false;
          if (err.status === 818) {
            const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
            if (route) {
              this.router.navigate([route]);
            }
          } else {
            this.utilsService.loadingFlights = false;
            this.flightLleegoService.letItGo(this.user, this.selectedFlights, this.travelersAge,
              this.flightSelectedStateBackup, this.farePricing, this.totalPrice, this.canUseResident, this.selectedBaggages, this.selectedPriority,
              this.extraInfoForm, this.fareName, this.fareSelected, this.residentOptions, this.projectData, this.userUuid,
              this.externalUser, this.canUseTRM, this.navigationExtras, lleegoBookingID, locator, paymentId,
              ancillaries, null, null, this.priceChanged, this.expectedAmountSeats, this.selectedSeats);
          }
        }
      );
    } else {
      this.flightLleegoService.redirectToInit(this.externalUser, this.canUseTRM, this.navigationExtras);
    }
  }

  preSelectSeats(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.flightLleegoService.getFlightStandalonecatalogue(this.paramsMap, "seatmap")
        .subscribe(
          (res) => {
            this.seatMap = res;
            this.utilsService.loadingFlights = false;

            const seatMapHasAvail =
              this.seatMap?.results?.length > 0 ||
              this.seatMap?.solutions?.[0]?.segments?.length > 0;

            const thereIsAvailWithSeats =
              seatMapHasAvail &&
              (
                (this.seatMap.results &&
                  this.seatMap.results.some((result: any) =>
                    result.segments &&
                    Object.values(result.segments).some((seg: any) =>
                      seg.seat_map != null &&
                      seg.seat_map.avail &&
                      Object.keys(seg.seat_map.avail).length > 0
                    )
                  )) ||
                (this.seatMap.solutions &&
                  this.seatMap.solutions[0]?.segments?.some((seg: any) =>
                    seg.seat_map != null &&
                    seg.seat_map.avail &&
                    (Array.isArray(seg.seat_map.avail)
                      ? seg.seat_map.avail.length > 0
                      : Object.keys(seg.seat_map.avail).length > 0)
                  ))
              );

            if (!thereIsAvailWithSeats) {
              return reject();
            }

            this.translate.get([
              "train.askingSeat",
              "common.confirm",
              "common.cancel",
              "train.user-select",
              "flight.seats-required"
            ]).subscribe((t) => {
              swal.fire({
                title: t["train.askingSeat"],
                text: t["flight.seats-required"],
                icon: "question",
                showCancelButton: true,
                confirmButtonText: t["train.user-select"],
                cancelButtonText: t["common.cancel"],
                customClass: {
                  confirmButton: "btn btn-success btn-raised custom-swal-button",
                  cancelButton: "btn btn-secondary btn-raised custom-swal-button",
                },
                buttonsStyling: false,
              }).then((action) => {
                const travellersData = this.flightLleegoService.createTravellersData(this.user);

                if (action.isConfirmed) {
                  const modalRef = this.dialog.open(FlightSeatsSelectionComponent, {
                    width: '80vw',
                    height: '80vh',
                    disableClose: true,
                    data: {
                      selectedFlights: this.selectedFlights,
                      userUuid: this.userUuid,
                      travelersAge: this.travelersAge,
                      isUser: this.isUser,
                      seatAvailabilityRes: this.seatMap,
                      token: this.seatMap.token,
                      totalPrice: this.totalPrice,
                      fareSelected: this.fareSelected,
                      paramsMap: this.paramsMap,
                      fromPreSelect: true,
                      selectedBaggages: this.selectedBaggages,
                      selectedPriority: this.selectedPriority,
                      selectedSeats: this.selectedSeats,
                      expected_amount: this.expectedAmountSeats,
                      farePricing: this.farePricing,
                      travellersData: travellersData,
                      totalFlightDuration: this.totalFlightDuration,
                      userFilters: this.userFilters,
                      company: this.company,
                      externalUser: this.externalUser
                    }
                  });

                  modalRef.afterClosed().subscribe((seatSelectionData) => {
                    const hasSelection =
                      !!seatSelectionData &&
                      Array.isArray(seatSelectionData.selectedSeats) &&
                      seatSelectionData.selectedSeats.length > 0;

                    if (hasSelection) {
                      const enrichedSeats = seatSelectionData.selectedSeats.map(seat => {
                              const flightInfo = this.getFlightInfoBySegment(seat.segment);
                              const legType = this.getLegTypeBySegment(seat.segment);
                              return {
                                ...seat,
                                departure: flightInfo?.object.departure,
                                arrival: flightInfo?.object.arrival,
                                type: legType,
                              };
                            });
                      this.selectedSeats = enrichedSeats;
                      seatSelectionData.selectedSeats = this.selectedSeats

                      this.expectedAmountSeats = seatSelectionData.expectedAmount;
                      this.totalPrice += seatSelectionData.expectedAmount || 0;
                      this.seatsByPassenger = seatSelectionData.seatsByPassenger;
                      resolve({
                        ...seatSelectionData,
                        requiresAuth: !!seatSelectionData.requiresAuth
                      });
                      return;
                    } else {
                      try {
                        if (!this.fareSelected.needsSeat || this.fareSelected.needsSeat.every((a) => a == false)) {
                          reject();
                        } else {
                          this.selectedSeats = [];
                          this.expectedAmountSeats = 0.0;
                          this.fareSelected.needsSeat.forEach((a, index) => {
                            if (a) {
                              const auto = this.autoAssignSeatsForAll(this.seatMap, travellersData, index);
                              this.selectedSeats.push(...auto.selectedSeats);
                              const enrichedSeats = this.selectedSeats.map(seat => {
                                const flightInfo = this.getFlightInfoBySegment(seat.segment);
                                const legType = this.getLegTypeBySegment(seat.segment);
                                  return {
                                    ...seat,
                                    departure: flightInfo?.object.departure,
                                    arrival: flightInfo?.object.arrival,
                                    type: legType,
                                  };
                                });
                              this.selectedSeats = enrichedSeats;

                              this.expectedAmountSeats += auto.expectedAmount || 0;
                              this.totalPrice += auto.expectedAmount || 0;
                              for (const [uuid, data] of Object.entries(auto.seatsByPassenger)) {
                                if (!this.seatsByPassenger) {
                                  this.seatsByPassenger = {};
                                }
                                if (!this.seatsByPassenger[uuid]) {
                                  this.seatsByPassenger[uuid] = { ...data };
                                } else {
                                  this.seatsByPassenger[uuid].seats.push(...data.seats);
                                  this.seatsByPassenger[uuid].total += data.total || 0;
                                }
                              }
                              resolve({selectedSeats: this.selectedSeats, expectedAmount: this.expectedAmountSeats, seatsByPassenger: this.seatsByPassenger, requiresAuth: false });
                            }
                          })
                        }
                      } catch {
                        reject();
                      }
                    }
                  });
                  return;
                } else if (action.isDismissed) {
                  if (!this.fareSelected.needsSeat || this.fareSelected.needsSeat.every((a) => a == false)) {
                    resolve({});
                  } else {
                    this.selectedSeats = [];
                    this.expectedAmountSeats = 0.0;
                    this.fareSelected.needsSeat.forEach((a, index) => {
                      if (a) {
                        const auto = this.autoAssignSeatsForAll(this.seatMap, travellersData, index);
                        this.selectedSeats.push(...auto.selectedSeats);
                        const enrichedSeats = this.selectedSeats.map(seat => {
                          const flightInfo = this.getFlightInfoBySegment(seat.segment);
                          const legType = this.getLegTypeBySegment(seat.segment);
                            return {
                              ...seat,
                              departure: flightInfo?.object.departure,
                              arrival: flightInfo?.object.arrival,
                              type: legType,
                            };
                          });
                        this.selectedSeats = enrichedSeats;
                        this.expectedAmountSeats += auto.expectedAmount || 0;
                        this.totalPrice += auto.expectedAmount || 0;
                        for (const [uuid, data] of Object.entries(auto.seatsByPassenger)) {
                          if (!this.seatsByPassenger) {
                            this.seatsByPassenger = {};
                          }
                          if (!this.seatsByPassenger[uuid]) {
                            this.seatsByPassenger[uuid] = { ...data };
                          } else {
                            this.seatsByPassenger[uuid].seats.push(...data.seats);
                            this.seatsByPassenger[uuid].total += data.total || 0;
                          }
                        }
                        resolve({selectedSeats: this.selectedSeats, expectedAmount: this.expectedAmountSeats, seatsByPassenger: this.seatsByPassenger, requiresAuth: false });
                      }
                    })
                  }
                }
              });
            });
          },
          () => reject()
        );
    }).catch((error) => {
      console.log(error)
      return { selectedSeats: [], expectedAmount: null, seatsByPassenger: null, requiresAuth: null }
    });
  }

  private availToArray(avail: any): Array<{ id: string; row: number; object: any[] }> {
    return Array.isArray(avail)
      ? avail
      : Object.entries(avail).map(([rowNumber, seats]: any) => ({
          id: rowNumber,
          row: parseInt(rowNumber, 10),
          object: Object.values(seats) as any[],
        }));
  }

  private extractSegments(seatMap: any): any[] {
    if (seatMap?.solutions?.[0]?.segments) return seatMap.solutions[0].segments;
    if (seatMap?.results?.[0]?.segments) return Object.values(seatMap.results[0].segments);
    return [];
  }

  private getFlightInfoBySegmentIndex(sIdx: number): any {
    const flattened: any[] = ([] as any[]).concat(...this.selectedFlights.map(s => s));
    return flattened[sIdx];
  }

  private autoAssignSeatsForAll(
    seatMap: any,
    travellersData: { uuid?: string }[],
    segmentIndex?: number
  ): {
    selectedSeats: any[];
    expectedAmount: number;
    seatsByPassenger: Record<string, { uuid: string; seats: any[]; total: number }>;
  } {
    const segments = this.extractSegments(seatMap);
    const paxCount = travellersData?.length || 1;

    const working =
      typeof segmentIndex === 'number'
        ? [JSON.parse(JSON.stringify(segments[segmentIndex]))]
        : JSON.parse(JSON.stringify(segments));

    const chosenSeats: any[] = [];
    let expected = 0;

    for (let sIdx = 0; sIdx < working.length; sIdx++) {
      const seg = working[sIdx];
      if (!seg?.seat_map?.avail) continue;

      const rows = this.availToArray(seg.seat_map.avail);

      for (let p = 0; p < paxCount; p++) {
        let candidate: { row: number; column: string; price: number } | null = null;
        let candidateSeat: any | null = null;

        outerFree:
        for (const row of rows) {
          for (const seat of row.object) {
            const price = seat?.price ?? seat?.object?.price ?? 0;
            const taken = seat?.taken === true || seat?.characteristics?.OccupiedSeat === true || seat?.selected === true;
            const isAisle = seat?.aisle === true;
            const col = seat?.object?.column ?? seat?.column;
            const r = seat?.object?.row ?? seat?.row ?? row.row;
            const isSeat = !isAisle && !!col;

            if (isSeat && !taken && Number(price) === 0) {
              candidate = { row: r, column: col, price: Number(price) };
              candidateSeat = seat;
              seat.taken = true;
              break outerFree;
            }
          }
        }

        if (!candidate) {
          let cheapest: { row: number; column: string; price: number } | null = null;
          let cheapestSeat: any | null = null;

          for (const row of rows) {
            for (const seat of row.object) {
              const price = Number(seat?.price ?? seat?.object?.price ?? Infinity);
              const taken = seat?.taken === true || seat?.characteristics?.OccupiedSeat === true || seat?.selected === true;
              const isAisle = seat?.aisle === true;
              const col = seat?.object?.column ?? seat?.column;
              const r = seat?.object?.row ?? seat?.row ?? row.row;
              const isSeat = !isAisle && !!col;

              if (isSeat && !taken && isFinite(price)) {
                if (!cheapest || price < cheapest.price) {
                  cheapest = { row: r, column: col, price };
                  cheapestSeat = seat;
                }
              }
            }
          }
          candidate = cheapest;
          candidateSeat = cheapestSeat;

          if (!candidate || !candidateSeat) {
            throw new Error("No hay suficientes asientos disponibles para asignación automática.");
          }

          candidateSeat.taken = true;
        }

        const paxIndex = p;
        const uuid = travellersData?.[paxIndex]?.uuid ?? null;

        const seatPaxRefs: string[] = (
          candidateSeat?.object?.pax_references ??
          candidateSeat?.pax_references ??
          []
        ).map(String);

        const assignedPaxRef = seatPaxRefs[paxIndex] ?? seatPaxRefs[0] ?? String(paxIndex + 1);

        const segCode =
          (candidateSeat?.object?.seg_references?.[0] ?? candidateSeat?.seg_references?.[0]) ??
          (seg?.source_i_d ?? seg?.id ?? String(sIdx));

        const realSegmentIndex =
          typeof segmentIndex === 'number' ? segmentIndex : sIdx;

        const picked = {
          row: candidate.row,
          column: candidate.column,
          pax: String(assignedPaxRef),
          pax_index: [paxIndex],
          segment: String(segCode),
          uuid,
          price: Number(candidate.price || 0),
        };

        const flightInfo = this.getFlightInfoBySegmentIndex(realSegmentIndex);
        chosenSeats.push({
          ...picked,
          departure: flightInfo?.object?.departure,
          arrival: flightInfo?.object?.arrival,
        });

        expected += Number(candidate.price || 0);
      }
    }

    const seatsByPassenger: Record<string, { uuid: string; seats: any[]; total: number }> = {};
    for (const seat of chosenSeats) {
      const key = seat.uuid || String(seat.pax);
      if (!seatsByPassenger[key]) {
        seatsByPassenger[key] = { uuid: seat.uuid || null, seats: [], total: 0 };
      }
      seatsByPassenger[key].seats.push(seat);
      seatsByPassenger[key].total += Number(seat.price || 0);
    }

    return { selectedSeats: chosenSeats, expectedAmount: expected, seatsByPassenger };
  }

  requestFlight() {
    this.utilsService.loadingFlights = true;
    let vyooPrice = this.priceChanged ? this.priceChanged : this.flightLleegoService.getVyooPrice(this.farePricing, this.totalPrice, this.canUseResident, this.selectedBaggages, this.selectedPriority);
    this.flightSelectedStateBackup = JSON.parse(JSON.stringify(this.stateService.flightSelectedState));
    const travellerData: Traveller[] = this.flightLleegoService.createTravellersData(this.user);
    let priceMap = this.getVyooPricePerTraveller(
      travellerData,
      this.seatsByPassenger ? this.seatsByPassenger : undefined
    );

    let seatSelection$ = this.emitOnBookingDetail.emit_on_booking && !this.selectedSeats
      ? from(this.preSelectSeats()).pipe(
          catchError((error) => {
            return of(null);
          })) : of(null);

    seatSelection$
      .subscribe((seatSelectionData): ObservableInput<any> => {
          this.utilsService.loadingFlights = true;
          const selectedSeats = seatSelectionData?.selectedSeats ?? this.selectedSeats;
          const expectedAmount = seatSelectionData?.expectedAmount ?? this.expectedAmountSeats;
          const seatsByPassenger = seatSelectionData?.seatsByPassenger ?? this.seatsByPassenger;

          if (selectedSeats?.length && seatsByPassenger) {
            if (expectedAmount && typeof expectedAmount === 'number' && !this.priceChanged) {
              vyooPrice = Number(vyooPrice || 0) + expectedAmount;
            } else if (this.priceChanged) {
                vyooPrice = Number(this.priceChanged);
            }
              priceMap = this.getVyooPricePerTraveller(
                travellerData,
                seatsByPassenger
              );
          }

          const airlines = [];
          const bookingQuery: BookingQuery = {
            token: this.lleegoToken,
            solutions: [
              {
                id: this.stateService.transportId ? this.stateService.transportId : (this.fareSelected ? this.fareSelected.id : this.solutionId),
                journeys: this.fareSelected
                  ? this.fareSelected.journeys_ids
                  : [this.journeysAssociations[0]?.journey_references[0]],
              },
            ],
            holder: {
              name: "VYOOTRIP",
              surnames: ["S L"],
              contact: {
                type: "Emergency",
                mails: ["reservas@vyootrip.com"],
                phones: [{
                  country_pref: "34",
                  number: "648200516",
                }],
                address: "C. Egido, 2",
                city: "Los Villares",
                postal_code: "23160",
                country: "ES",
              }
            },
            travellers: travellerData,
            seats: selectedSeats ?? [],
            vyooPrice: vyooPrice,
            vyooPriceMap: priceMap,
            solutionIva: this.solutionIva,
          };
          if (this.journeysAssociations[1]?.journey_references[0] != null) {
            bookingQuery.solutions[0].journeys.push(
              this.journeysAssociations[1]?.journey_references[0]
            );
          }
          const priorityNormalized = this.normalizePriorityForBooking(this.selectedPriority);

          const ancillaries = [
            ...(this.selectedBaggages || []),
            ...priorityNormalized,
          ].filter(a => a?.id != null);

          if (ancillaries.length > 0) bookingQuery.ancillaries = ancillaries;
          const confirmDto = {
            from: this.stateService.flightSearchForm.value.origin,
            to: this.stateService.flightSearchForm.value.destination,
            departureDate: new Date(this.selectedFlights[0][0].object.departure_date),
            returnDate:
              this.selectedFlights.length > 1
                ? new Date(this.selectedFlights[1][0].object.departure_date)
                : null,
            oneWay:
              this.stateService.flightSearchForm.value.roundtrip === "false"
                ? true
                : false,
            annotations: "Solicitud de vuelo personalizado con preautorización",
            customCode: this.extraInfoForm.value.customCode,
            costCenter: this.extraInfoForm.value.costCenter,
            travellerReason: this.extraInfoForm.value.travellerReason,
            annotationsExtras: this.extraInfoForm.value.annotationsExtras,
            userUuid: this.userUuid,
            emitOnBookingDetail: this.emitOnBookingDetail,
            scales: this.scalesInfo,
            totalTime: this.totalTime,
            arrivalDate: this.arrivalDate,
            query: bookingQuery,
            expectedAmount: expectedAmount,
            baggagesPrice: Number(this.getTotalBaggagePrice()),
            vyooCommission: this.fareSelected.vyooCommission,
            seatsByPassenger: seatsByPassenger,
            selectedBaggages: this.selectedBaggages,
            selectedPriority: this.selectedPriority,
            priorityPrice: this.getTotalPriorityPrice()
          };
          confirmDto["departureLocalDate"] = this.formatLocalDate(confirmDto["departureDate"])
          if (confirmDto["returnLocalDate"])
            confirmDto["returnLocalDate"] = this.formatLocalDate(confirmDto["returnDate"])
          const calculateStopDurations = (flights: any[]) => {
            const stopDurations = [];
            for (let i = 0; i < flights.length - 1; i++) {
              const currentArrival = moment(flights[i].object.arrival_date);
              const nextDeparture = moment(flights[i + 1].object.departure_date);
              const duration = moment.duration(nextDeparture.diff(currentArrival));
              stopDurations.push({
                arrival: flights[i].object.arrival,
                departure: flights[i + 1].object.departure,
                duration: `${duration.hours()}h ${duration.minutes()}m`,
                durationInMinutes: duration.asMinutes()
              });
            }
            return stopDurations;
          };

          const goingStopsDuration = calculateStopDurations(this.selectedFlights[0]);

          let returnStopsDuration = [];
          if (this.selectedFlights.length > 1) {
            returnStopsDuration = calculateStopDurations(this.selectedFlights[1]);
          }

          if (this.selectedFlights.length > 0) {
            const outwardAirline = this.selectedFlights[0][0].object.marketing_company;
            airlines.push(outwardAirline);
          }

          if (this.selectedFlights.length > 1) {
            const returnAirline = this.selectedFlights[1][0].object.marketing_company;
            airlines.push(returnAirline);
          }

          confirmDto["airlines"] = airlines;

          if (this.fareSelected && this.fareName) {
            bookingQuery['fares'] = { fareName: this.fareName, fareSelected: this.fareSelected };
          }

          const goingStops = this.selectedFlights[0].slice(
            1,
            this.selectedFlights[0].length
          );
          let goingText = "Escala Ida:";
          if (goingStops.length > 1) {
            goingText = "Escalas Ida:";
          }

          const body = {
            itinerary: `Ida: (${this.selectedFlights[0][0].airline.name
              }) ${this.flightLleegoService.getAirportName(this.selectedFlights[0][0].object.departure, this.flightSelectedStateBackup)}  - ${this.flightLleegoService.getAirportName(this.selectedFlights[0][this.selectedFlights[0].length - 1].object.arrival, this.flightSelectedStateBackup)}`,
            travellers: this.arrayTravelers.length,
            dates: moment(this.selectedFlights[0][0].object.departure_date).format(
              "DD/MM/YYYY HH:mm"
            ),
            price: this.priceChanged ? this.priceChanged : vyooPrice,
            stops: null,
            seats: selectedSeats ?? [],
            baggages: this.baggagesInfo,
            stopsText: null,
          };

          if (goingStops.length > 0) {
            body.stopsText = `${goingText} ${goingStops
              .map((seg, index) => {
                const arrivalTime = moment(this.selectedFlights[0][index].object.arrival_date).format("HH:mm");
                const departureTime = moment(this.selectedFlights[0][index + 1].object.departure_date).format("HH:mm");
                const arrivalCity = this.selectedFlights[0][index].object.arrival;
                const nextArrivalCity = this.selectedFlights[0][index + 1]?.object.arrival;
                return `${this.flightLleegoService.getAirportName(seg.object.departure, this.flightSelectedStateBackup)}-${this.flightLleegoService.getAirportName(seg.object.arrival, this.flightSelectedStateBackup)} (Aerolínea: ${seg.airline.name}) (IATA aerolinea: ${seg.object.marketing_company}) duración: ${goingStopsDuration[index]?.duration || "N/A"}, llega a ${arrivalCity} a las ${arrivalTime}, sale hacia ${nextArrivalCity} a las ${departureTime}`;
              })
              .join(", ")}`;
          } else {
            body.stopsText = `${goingText} ninguna`;
          }
          body.stops = goingStops.length;
          if (this.selectedFlights.length > 1) {
            body.dates =
              moment(this.selectedFlights[0][0].object.departure_date).format(
                "DD/MM/YYYY HH:mm"
              ) +
              " - " +
              moment(
                this.selectedFlights[this.selectedFlights.length - 1][
                  this.selectedFlights[this.selectedFlights.length - 1].length - 1
                ].object.departure_date
              ).format("DD/MM/YYYY HH:mm");
            const returnStops = this.selectedFlights[
              this.selectedFlights.length - 1
            ].slice(1, this.selectedFlights[this.selectedFlights.length - 1].length);
            let returnText = "Escala Vuelta:";
            if (returnStops.length > 1) {
              returnText = "Escalas Vuelta:";
            }
            body.itinerary += `\nVuelta: (IATA aerolinea: ${this.selectedFlights[this.selectedFlights.length - 1][0].object
              .marketing_company
              }) ${this.selectedFlights[this.selectedFlights.length - 1][0].object
                .departure
              } - ${this.selectedFlights[this.selectedFlights.length - 1][
                this.selectedFlights[this.selectedFlights.length - 1].length - 1
              ].object.arrival
              }`;

            if (returnStops.length > 0) {
              body.stopsText += `\n${returnText} ${returnStops
                .map((seg, index) => {
                  const arrivalTime = moment(this.selectedFlights[1][index].object.arrival_date).format("HH:mm");
                  const departureTime = moment(this.selectedFlights[1][index + 1]?.object.departure_date).format("HH:mm");
                  const arrivalCity = this.selectedFlights[1][index].object.arrival;
                  const nextArrivalCity = this.selectedFlights[1][index + 1]?.object.arrival;
                  return `${this.flightLleegoService.getAirportName(seg.object.departure, this.flightSelectedStateBackup)}-${this.flightLleegoService.getAirportName(seg.object.arrival, this.flightSelectedStateBackup)} (Aerolínea: ${seg.airline.name}) (IATA aerolinea: ${seg.object.marketing_company}) duración: ${returnStopsDuration[index]?.duration || "N/A"}, llega a ${arrivalCity} a las ${arrivalTime}, sale hacia ${nextArrivalCity} a las ${departureTime}`;
                })
                .join(", ")}`;
            } else {
              body.stopsText += `\n${returnText} ninguna`;
            }
            body.stops += returnStops.length;
          }
          confirmDto["letItGoInfo"] = body;
          if (this.availablePayments) {
            confirmDto["availablePayments"] = this.availablePayments;
          }
          const authorization = {
            type: "flight",
            price: this.priceChanged ? this.priceChanged : vyooPrice,
            requestData: confirmDto,
            fromDate: this.selectedFlights[0][0].object.departure_date,
            toDate:
              this.selectedFlights.length > 1
                ? this.selectedFlights[1][0].object.departure_date
                : null,
            userUuid: this.userUuid,
            customCode: this.extraInfoForm.value.customCode,
            costCenter: this.extraInfoForm.value.costCenter,
            travellerReason: this.extraInfoForm.value.travellerReason,
            annotationsExtras: this.extraInfoForm.value.annotationsExtras,
          };

          if (this.fareSelected) {
            confirmDto["fareSelected"] = this.fareSelected;
          }
          if (ancillaries.length > 0) {
            confirmDto.query["ancillaries"] = ancillaries;
          }

          if (this.projectData && this.projectData?.selectedProject && this.projectData?.selectedProject?.uuid) {
            authorization['selectedProjectId'] = this.projectData.selectedProject.uuid;
          }
          if (this.accomInfo) {
            this.doBooking(this.accomInfo.searchConfig, this.accomInfo.bookingInfo, this.accomInfo.hotel, this.accomInfo.selectedTravelers, this.accomInfo.uuidUser, this.accomInfo.guests, this.accomInfo.company, this.accomInfo.selectedCard, this.accomInfo.isEmployee, this.accomInfo.isAdmin, this.accomInfo.canRequest, this.accomInfo.userFilter, this.accomInfo.canOnlyRequestRooms, this.accomInfo.selectedUsers, this.accomInfo.projectData, this.accomInfo.selectedRooms, this.accomInfo.canUseTRM, this.accomInfo.totalAdults, this.accomInfo.selectedOccupancy, this.accomInfo.externalUser, this.accomInfo.isUser)
          }
          if (this.isPackageRate && this.isPackageRate == 'flight') {
            localStorage.setItem('packageRateFlightInfo', JSON.stringify({
              baggagesNumber: this.getBaggagesNumber(), 
              bookingQuery,
              canUseResident: this.canUseResident,
              canUseTRM: this.canUseTRM,
              expectedAmountSeats: this.expectedAmountSeats,
              externalUser: this.externalUser,
              extraInfoForm: this.extraInfoForm.getRawValue(),
              fareName: this.fareName,
              farePricing: this.farePricing,
              fareSelected: this.fareSelected,
              flightRequest: authorization,
              flightSelectedStateBackup: this.flightSelectedStateBackup,
              isAuthorization: true,
              isOverDurationLimit: this.isOverDurationLimit,
              isPriceWithinRange: this.isPriceWithinRangeMethod(this.getPriceStep),
              navigationExtras: this.navigationExtras,
              priceChanged: this.priceChanged,
              projectData: this.projectData,
              residentOptions: this.residentOptions,
              selectBaggage: this.selectBaggage,
              selectedBaggages: this.selectedBaggages,
              selectedPriority: this.selectedPriority,
              selectedFlights: this.selectedFlights,
              selectedSeats: this.selectedSeats,
              totalBaggagePrice: this.getTotalBaggagePrice(),
              priorityPrice: this.getTotalPriorityPrice(),
              totalPrice: this.totalPrice,
              travelersAge: this.travelersAge,
              user: this.user,
              userUuid: this.userUuid,
            }))
            if (this.isAdmin) {
              localStorage.setItem("userToBook", this.utilsService.encrypt(this.userUuid));
              this.router.navigate([`search/${this.userUuid}`])
            } else {
              this.router.navigate([`search`])
            }
            this.utilsService.loadingFlights = false;
            return of(null);
          } else {
            this.flightLleegoService.requestAuthorization(authorization, this.externalUser, this.canUseTRM, this.navigationExtras);
          }
        }, (error) =>{console.log(error)}), filter((result) => result !== null)
  }

  formatLocalDate(d) {
  const pad = n => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

  deleteTrav(id: string) {
    this.arrayDataTravelers.forEach((e) => {
      if (e.id === id) {
        this.arrayDataTravelers.splice(this.arrayDataTravelers.indexOf(e), 1);
      }
    });
  }

  handleTravelFlow(flight: any) {
    const checkInAux = moment(flight.departDate).format("YYYY-MM-DD");
    const bookingData: any = {
      initDate: checkInAux,
      bookingUuid: flight.uuid,
      type: "flight",
    };
    if (flight.returnDate != null) {
      const checkOutAux = moment(flight.returnDate).format("YYYY-MM-DD");
      bookingData.endDate = checkOutAux;
    }

    bookingData["userUuid"] = this.userUuid;
    const dialogAssignProject = this.dialog.open(DialogAssignProjectComponent, {
      data: { bookingData, isUser: this.isUser, isNewBooking: true },
      panelClass: "new-dialog",
    });
    return dialogAssignProject.afterClosed();
  }

  onGetPDF(booked: any) {
    let fileName;
    if (booked.voucherFile && Array.isArray(booked.voucherFile) && booked.voucherFile.length > 0) {
      const firstFile = booked.voucherFile[0];
      fileName = firstFile.fileName || 'flight_bonus.pdf';
    }
    else if (booked.voucherFileUrl) {
      fileName = 'flight_bonus.pdf';
    }

    this.bookedService
      .getBookedsPdf(booked.voucherFileUrl)
      .pipe(take(1))
      .subscribe(
        (res) => {
          const modalRef = this.modalService.open(ViewPdfModalComponent, {
            size: "lg",
            centered: true,
          });
          modalRef.componentInstance.blobUrl = URL.createObjectURL(res);
          modalRef.componentInstance.fileName = fileName;
        },
        () =>
          this.translate
            .get(["common.error-pdf"])
            .pipe(take(1))
            .subscribe((value) =>
              this.ngxToastrService.typeInfo(null, value["common.error-pdf"])
            )
      );
  }

  updateBaggagePrice(event: any) {
    this.baggagePrice = 0;

    for (const foundBaggage of event || []) {
      const passengerCount =
        Array.isArray(foundBaggage?.pax_index) ? foundBaggage.pax_index.length :
        Array.isArray(foundBaggage?.pax_references) ? foundBaggage.pax_references.length :
        1;

      this.baggagePrice += Number(foundBaggage?.total || 0) * passengerCount;
    }

    this.selectedBaggages = event;
  }

  getSeatMap(event: any) {
    this.paramsMap = event.params;
  }

  openPoliciesDialog(multi) {
    this.flightLleegoService
      .getFlightPolicy({
        token: this.lleegoToken,
        solutionID0: multi.id,
        journey00: this.journeysAssociations[0]?.journey_references[0],
        journey01: this.journeysAssociations[1]?.journey_references[0],
        userUuid: this.isUser ? null : this.userUuid,
      })
      .subscribe(
        (res) => {
          if (res.error != null) {
            this.translate.get("flight.form-flight.error").subscribe((resp) => {
              this.ngxToastrService.typeInfo(resp, "");
              this.router.navigateByUrl("flight");
              this.utilsService.loadingFlights = false;
            });
          } else {
            if (
              res.solutions[0].penalties != null &&
              res.solutions[0].penalties.length > 0
            ) {
              this.policiesSolutionPenalties = res.solutions[0].penalties;
              this.dialog.open(DialogPoliciesComponent, {
                width: "60%",
                height: "60%",
                panelClass: "dialog-policies",
                data: this.policiesSolutionPenalties,
              });
            }
          }
        },
        (err) => {
          this.translate.get("flight.form-flight.error").subscribe((resp) => {
            this.loadingFlight = false;
            this.utilsService.loadingFlights = false;
          });
        }
      );
  }

  updateAuthPriceOverDuration(): void {
    const over = this.userFilters?.allowAmountOverDuration;
    const price = Number(this.totalPrice) || 0;
    const maxLegHours = Number(this.totalFlightDuration) || 0;

    if (over?.amount != null && over?.duration != null && maxLegHours) {
      const anyLegExceeds = maxLegHours >= Number(over.duration);
      const exceptionApplies = anyLegExceeds && price <= Number(over.amount);

      const withinBase = this.isPriceWithinRangeMethod(price);
      const needsAuthWhenBase = !withinBase && !exceptionApplies;

      this.isOverDurationLimit = needsAuthWhenBase;
    } else {
      this.isOverDurationLimit = !this.isPriceWithinRangeMethod(price);
    }
  }

  goBack() {
    if (this.didSearch == true) {
      this.stateService.selectedPolicy = this.selectedPolicy;
      this.stateService.userFilters = this.userFilters;

      this.router.navigate(['/flight'], {
        queryParams: { didSearch: true },
        state: {
          selectedPolicy: this.selectedPolicy,
          userFilters: this.userFilters,
        }
      });
    } else {
      history.back();
    }
  }

  getOptimusMultifamily(multifamily: MultifamilyRS) {
    if (multifamily && multifamily.fares.length >= 1) {
      multifamily.fares.forEach((fare) => {
        fare.touched = false;
      });
      const optimusMultifamilyFares = [multifamily.fares[0]];
      if (multifamily.fares.length > 3) {
        multifamily.fares.shift();
        const sortFares = this.sortFaresByPrice(multifamily.fares);
        const middleFare = sortFares[Math.floor((sortFares.length - 1) / 2)];
        optimusMultifamilyFares.push(middleFare);
        optimusMultifamilyFares.push(
          multifamily.fares[multifamily.fares.length - 1]
        );
        const optimusMultiFamily: MultifamilyRS = {
          token: multifamily.token,
          fares: optimusMultifamilyFares,
        };

        optimusMultiFamily.fares.forEach((fare) => {
          if (fare.services && fare.services.length > 1) {
            fare.services.forEach((service) => {
              if (service && service.name && service.name !== "") {
                service.name = service.name?.toLowerCase();
              }
            });
          }
        });

        return optimusMultiFamily;
      } else {
        multifamily.fares.forEach((fare) => {
          if (fare.services && fare.services.length > 1) {
            fare.services.forEach((service) => {
              if (service && service.name && service.name !== "") {
                service.name = service.name?.toLowerCase();
              }
            });
          }
        });
        return multifamily;
      }
    } else {
      return { token: "", fares: [] };
    }
  }

  sortFaresByPrice(fares: Fares[]) {
    fares.sort((a, b) => {
      // return (a.services.length -1) - (b.services.length - 1);
      return a.total - b.total;
    });
    return fares;
  }

  nextStepFromFares(event) {
    this.fareSelected = event.fare;
    this.fareName = event.fareName;
    this.stepper.next();
  }
  backStepFromFares() {
    this.fareSelected = null;
    this.stepper.previous();
  }

  goNextStep(event) {
    if (
      event &&
      event.needDocApis !== null &&
      event.needAddress !== null &&
      event.emitOnBookingDetail !== null
    ) {
      this.needAddress = event.needAddress;
      this.needDocApis = event.needDocApis;
      this.emitOnBookingDetail = event.emitOnBookingDetail;
      this.availablePayments = event.availablePayments;
      this.totalPrice = event.totalPrice;
      this.selectBaggage = event.selectBaggage ?? '';
      this.farePricing = event.farePricing ?? null;
      this.getPriceStep = event.getPrice;
      this.selectedBaggages = Array.isArray(this.selectBaggage)
        ? this.selectBaggage.map((bag) => this.enrichBaggageWithFlightInfo(bag))
        : [];
      this.selectedPriority = event.selectPriority ?? [];
      this.priorityPrice = this.getTotalPriorityPrice();
      this.pricing = event.pricing;
      this.passengerBookingParams = event.passengerBookingParams ?? null;
    }
    this.updateAuthPriceOverDuration();
    this.stepper.next();
  }

  goToFirstStep() {
    this.stepper.selectedIndex = 0;
  }

  isFareWithinRange(totalPrice: any): boolean {
    if (
      !this.userFilters ||
      this.userFilters?.priceMinFlight == null ||
      this.userFilters?.priceMaxFlight == null
    ) {
      return true;
    }
    return (
      totalPrice >= this.userFilters.priceMinFlight &&
      totalPrice <= this.userFilters.priceMaxFlight
    );
  }

  isPriceWithinRangeMethod(totalPrice: number): boolean {
    if (
      !this.userFilters ||
      this.userFilters?.priceMinFlight == null ||
      this.userFilters?.priceMaxFlight == null
    ) {
      return true;
    }

    return (
      totalPrice >= this.userFilters.priceMinFlight &&
      totalPrice <= this.userFilters.priceMaxFlight
    );
  }


  getTotalBaggagePrice(): number {
    if (!this.selectedBaggages || this.selectedBaggages.length === 0) {
      return 0;
    }

    return this.selectedBaggages.reduce((sum, baggage) => {
      const passengerCount =
        Array.isArray(baggage?.pax_index) ? baggage.pax_index.length :
        Array.isArray(baggage?.pax_references) ? baggage.pax_references.length :
        1;

      return sum + (Number(baggage.total || 0) * passengerCount);
    }, 0);
  }

  getAirportName(iataCode: string): string {
    const airportData = this.flightSelectedStateBackup.data.port[iataCode];
    return airportData ? airportData.name : iataCode;
  }

  goBackStep($event) {
    this.stepper.previous();
  }

  getBaggagesNumber() {
    let total = 0;

    (this.selectedBaggages || []).forEach((b) => {
      total +=
        Array.isArray(b?.pax_index) ? b.pax_index.length :
        Array.isArray(b?.pax_references) ? b.pax_references.length :
        1;
    });

    return total;
  }

  getFlightInfoBySegment(segmentCode: string) {
    const allFlights = this.selectedFlights.reduce((acc, val) => acc.concat(val), []);
    return allFlights.find(flight => {
      const fullSegment = `${flight.object.marketing_company}${flight.object.transport_number}`;
      return segmentCode.startsWith(fullSegment) || segmentCode === flight.id;
    });
  }

  private getLegTypeBySegment(segmentCode: string): 'outbound' | 'return' | '' {
    if (!segmentCode || !Array.isArray(this.selectedFlights)) return '';

    const [outbound = [], ret = []] = this.selectedFlights;
    const outIds = new Set(outbound.map(f => f?.id).filter(Boolean));
    const retIds = new Set(ret.map(f => f?.id).filter(Boolean));

    const outPrefixes = new Set(
      outbound
        .map(f => `${f?.object?.marketing_company ?? ''}${f?.object?.transport_number ?? ''}`.trim())
        .filter(p => p.length > 0)
    );
    const retPrefixes = new Set(
      ret
        .map(f => `${f?.object?.marketing_company ?? ''}${f?.object?.transport_number ?? ''}`.trim())
        .filter(p => p.length > 0)
    );

    const code = String(segmentCode).trim();

    if (outIds.has(code)) return 'outbound';
    if (retIds.has(code)) return 'return';

    for (const p of outPrefixes) if (p && code.startsWith(p)) return 'outbound';
    for (const p of retPrefixes) if (p && code.startsWith(p)) return 'return';

    return '';
  }

  ngOnDestroy() {
    localStorage.removeItem('stateFlightRedirect');
    this.utilsService.socket.off('create-booking');
    this.subcriptions.forEach((s) => s.unsubscribe());
  }

  getTotalPriceAccom() {
    let totalPrice = 0;
    this.accomInfo.selectedRooms.forEach((room) => {
      room.rates.forEach((rate) => {
        totalPrice += rate.price && rate.price.totalPrice ? Number(rate.price.totalPrice.total) : Number(rate.totalWithPercentage);
      })
    })
    return totalPrice;
  }

  getTotalPackage() {
    return this.totalPrice + this.getTotalPriceAccom()
  }

  doBooking(searchConfig, bookingInfo, hotel, selectedTravelers, uuidUser, guests, company, selectedCard, isEmployee, isAdmin, canRequest, userFilter, canOnlyRequestRooms, selectedUsers, projectData, selectedRooms, canUseTRM, totalAdults, selectedOccupancy, externalUser, isUser) {
    this.utilsService.loadingHotels = true;
    const checkInAux = moment(
      moment(
        this.ngbDateParser.format(searchConfig.checkIn),
        "DD/MM/YYYY"
      ).toLocaleString()
    ).format("YYYY-MM-DD");
    const checkOutAux = moment(
      moment(
        this.ngbDateParser.format(searchConfig.checkOut),
        "DD/MM/YYYY"
      ).toLocaleString()
    ).format("YYYY-MM-DD");

    bookingInfo.rooms.forEach((room, index) => {
      const params = {
        rooms: [room],
        destinationName: hotel.address,
        checkIn: checkInAux,
        checkOut: checkOutAux,
        userUuid: selectedTravelers[index] ?? [uuidUser],
        comments: bookingInfo.adminHotelComment ?? "",
        hotelName: hotel.name,
        guests: guests.splice(0, room.paxes.length),
      };

      if (!company.bookedWithoutCard && selectedCard) {
        params["paymentCard"] = {
          name: selectedCard.name,
          token: selectedCard.token,
        };
      }
      if (bookingInfo.customCode !== "") {
        params["customCode"] = bookingInfo.customCode;
      }
      if (bookingInfo.costCenter !== "") {
        params["costCenter"] = bookingInfo.costCenter;
      }
      params["hotel"] = hotel;
      params["hotel"].rooms = [room];
      if (isEmployee || isAdmin) {
        canRequest = true;
      }
      if ((this.getUserBookingOption(room.rates[0], userFilter, searchConfig.checkIn, searchConfig.checkOut, canOnlyRequestRooms) === 1 && canRequest && !canOnlyRequestRooms) || isEmployee || isAdmin) {
        const bookingInfoForBooking = { ...bookingInfo };
        delete bookingInfoForBooking.travellerReason;
        this.createBooking(params, room, bookingInfo.rooms.indexOf(room), bookingInfoForBooking, selectedUsers, hotel, projectData, selectedRooms, canUseTRM, searchConfig, totalAdults);
      } else {
        this.createAuthorization(bookingInfo, params, isUser, uuidUser, projectData, externalUser, canUseTRM, selectedRooms, hotel, searchConfig, totalAdults, selectedOccupancy);
      }
    });
  }

  createBooking(params, roomBooked, roomBookedIdx, bookingInfo, selectedUsers, hotel, projectData, selectedRooms, canUseTRM, searchConfig, totalAdults) {
    const correlation = crypto.randomUUID();
    const userIndex = selectedUsers.findIndex(user => user.uuid === params.userUuid);
    if (userIndex !== -1) {
      selectedUsers[userIndex].correlationId = correlation;
    }

    const { latitude, longitude } = params.hotel.coordinates;
    this.googleMaps.geocodeLatLng(Number(latitude), Number(longitude)).subscribe(
      (result) => {
        if (result && result.city) {
          params.hotel.destinationName = result.city;
          hotel.destinationName = result.city;
        }
        this.finalizeBooking(params, roomBooked, roomBookedIdx, bookingInfo, correlation, selectedUsers, hotel, projectData, selectedRooms, canUseTRM, searchConfig, totalAdults);
      },
      (error) => {
        this.finalizeBooking(params, roomBooked, roomBookedIdx, bookingInfo, correlation, selectedUsers, hotel, projectData, selectedRooms, canUseTRM, searchConfig, totalAdults);
      }
    );
  }

  createAuthorization(bookingInfo, params, isUser, uuidUser, projectData, externalUser, canUseTRM, selectedRooms, hotel, searchConfig, totalAdults, selectedOccupancy) {
    const { latitude, longitude } = params.hotel.coordinates;
    this.googleMaps.geocodeLatLng(Number(latitude), Number(longitude)).subscribe(
      (result) => {
        if (result && result.city) {
          params.hotel.destinationName = result.city;
        }
        this.proceedWithAuthorization(bookingInfo, params, isUser, uuidUser, projectData, externalUser, canUseTRM, selectedRooms, hotel, searchConfig, totalAdults, selectedOccupancy);
      },
      (error) => {
        this.proceedWithAuthorization(bookingInfo, params, isUser, uuidUser, projectData, externalUser, canUseTRM, selectedRooms, hotel, searchConfig, totalAdults, selectedOccupancy);
      }
    );
  }

  getUserBookingOption(rate, userFilter, checkIn, checkOut, canOnlyRequestRooms) {
    let { priceMin, priceMax } = userFilter;
    let checkInAux = moment(
      this.ngbDateParser.format(checkIn),
      "DD/MM/YYYY"
    ).toString();
    let checkOutAux = moment(
      this.ngbDateParser.format(checkOut),
      "DD/MM/YYYY"
    ).toString();

    checkIn = new Date(checkInAux);
    checkOut = new Date(checkOutAux);

    let milisecondDiference = Math.abs(checkOut.getTime() - checkIn.getTime());
    let totalNights = Math.floor(milisecondDiference / (1000 * 60 * 60 * 24));

    let totalPriceMax = totalNights * priceMax;

    if (
      (rate.totalWithPercentage > priceMin &&
        rate.totalWithPercentage < totalPriceMax) && !canOnlyRequestRooms
    ) {
      return 1;
    } else {
      return 2;
    }
  }

  proceedWithAuthorization(bookingInfo, params, isUser, uuidUser, projectData, externalUser, canUseTRM, selectedRooms, hotel, searchConfig, totalAdults, selectedOccupancy) {
    let requestParams = {
      type: "booking",
      bookingData: params,
    };
    if (!isUser) {
      requestParams["userUuid"] = uuidUser;
    }
    requestParams["price"] =
      requestParams["bookingData"].rooms[0].net;
    if (bookingInfo.customCode !== "") {
      requestParams["customCode"] = bookingInfo.customCode;
    }
    if (bookingInfo.costCenter !== "") {
      requestParams["costCenter"] = bookingInfo.costCenter;
    }
    if (bookingInfo.travellerReason !== "") {
      requestParams["travellerReason"] = bookingInfo.travellerReason;
    }
    const correlation = crypto.randomUUID();
    this.utilsService.correlationId.push(correlation);
    requestParams.bookingData['correlationId'] = correlation;
    if (projectData && projectData.selectedProject && projectData.selectedProject.uuid) {
      requestParams['selectedProjectId'] = projectData.selectedProject.uuid;
    }

    this.bookedService.requestAuthorization(requestParams).subscribe(
      () => {
        this.utilsService.loadingHotels = false;
        this.translate
          .get([
            "common.congrat",
            "search.search-booked.success-room-request",
          ])
          .subscribe((response) => {
            Swal.fire({
              position: "center",
              imageUrl: "../../../../../assets/img/svg/check-circle.svg",
              title: response["common.congrat"],
              text: response["search.search-booked.success-room-request"],
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
              if (route) {
                this.router.navigate([route]);
              }
            });
          });
        this.authService.totalAuthorizations++;
      },
      (err) => {
        if (err.status === 403 && err.error?.message === "This action is not allowed in this plan") {
          this.translate.get("authorization.not-allowed-plan").subscribe((translatedMessage) => {
            this.ngxToastrService.typeInfo('', translatedMessage);
          });
          Swal.close();
          this.utilsService.loadingHotels = false;
          const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
          if (route) {
            this.router.navigate([route]);
          }
          return;
        }
        Swal.close();
        this.utilsService.loadingHotels = false;
        const author = [this.externalUser?.name, this.externalUser?.lastname]
          .filter(Boolean)
          .join(" ")
          .trim();
        const body = {
          hotel: {
            name: hotel.name,
            totalRooms: searchConfig.occupancies.length,
            room: {
              adults: totalAdults,
              price:
                params.rooms[0].rates[0].totalWithPercentage ||
                `${params.rooms[0].rates[0].net}`,
              roomNumber: this.getCurrentOccupancyIndex(searchConfig, selectedOccupancy),
              roomName: params.rooms[0].name,
            },
            address: hotel.address,
          },
          totalPrice: this.totalPrice.toLocaleString("es-ES", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          }),
          cancellationPolicies: params.rooms[0].rates[0].cancellationPolicies[0]?.from,
          checkIn: moment(new Date(params.checkIn)).format("DD/MM/YYYY"),
          checkOut: moment(new Date(params.checkOut)).format("DD/MM/YYYY"),
          author: author || "No consta",
        };
        this.travelUtilsService.removeTravelLocalStorage();
        if (bookingInfo.customCode !== "") {
          body["customCode"] = bookingInfo.customCode;
        }
        if (bookingInfo.costCenter !== "") {
          body["costCenter"] = bookingInfo.costCenter;
        }

        if (bookingInfo.adminHotelComment !== "") {
          body["comments"] = bookingInfo.adminHotelComment;
        }

        if (selectedRooms[this.getCurrentOccupancyIndex(searchConfig, selectedOccupancy)].rates[0].boardCode === "BB") {
          body["breakfast"] = true;
        } else {
          body["breakfast"] = false;
        }

        if (selectedRooms[this.getCurrentOccupancyIndex(searchConfig, selectedOccupancy)]?.rates[0]?.boardName) {
          body["boardName"] =
            selectedRooms[this.getCurrentOccupancyIndex(searchConfig, selectedOccupancy)].rates[0].boardName;
        }

        if (selectedRooms[this.getCurrentOccupancyIndex(searchConfig, selectedOccupancy)].rates[0].cancellationPolicies) {
          body["cancellation"] = true;
          body["cancellationDate"] =
            selectedRooms[this.getCurrentOccupancyIndex(searchConfig, selectedOccupancy)].rates[0].cancellationPolicies[0]?.from;
        } else {
          body["cancellation"] = false;
        }
        if (this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid !== "none") {
          body["project"] = this.projectData.selectedProject.title || "";
        }

        this.utilsService.sendEmailOperations(
          LetItGoType.hotel,
          body,
          uuidUser
        );
        const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
        if (route) {
          this.router.navigate([route]);
        }
      }
    );
  }

  finalizeBooking(params, roomBooked, roomBookedIdx, bookingInfo, correlation, selectedUsers, hotel, projectData, selectedRooms, canUseTRM, searchConfig, totalAdults) {
    this.utilsService.correlationId.push(correlation);
    params['correlationId'] = correlation;
    bookingInfo.rooms[roomBookedIdx].correlationId = correlation;
    bookingInfo = bookingInfo;

    this.utilsService.setSelectedUsers(selectedUsers);
    this.utilsService.setBookingInfo(bookingInfo);
    this.utilsService.setHotelInfo(hotel);
    this.utilsService.setSelectedRooms(selectedRooms);
    this.utilsService.setProjectData(projectData);
    this.bookedService.createBooked(params).subscribe(
      (created: any) => {
      },
      (err) => {
        this.createBookingFailed(err, roomBooked, roomBookedIdx, params, bookingInfo, canUseTRM, selectedRooms, hotel, searchConfig, totalAdults);
      }
    );
  }

  createBookingFailed(err, roomBooked, roomBookedIdx, params, bookingInfo, canUseTRM, selectedRooms, hotel, searchConfig, totalAdults) {
      this.travelUtilsService.removeTravelLocalStorage();
      Swal.close();
      this.utilsService.loadingHotels = false;
  
      // Se comprueba si es letitgo o si es fallo de tarjeta
      if (
        err.status === 422 &&
        err.error &&
        err.error.message ===
          "No tienes permisos para realizar la reserva sin tarjeta de crédito"
      ) {
        this.translate
          .get(["common.card-permission-error"])
          .pipe(take(1))
          .subscribe((value) =>
            this.ngxToastrService.typeInfo(
              null,
              value["common.card-permission-error"]
            )
          );
      } else if (err && err.status === 422) {
        this.translate
          .get(["agency.search.search-booked.error-room-booked"])
          .pipe(take(1))
          .subscribe((value) =>
            this.ngxToastrService.typeInfo(
              null,
              value["agency.search.search-booked.error-room-booked"]
            )
          );
      } else {
        // Se elimina el mensaje de error para poner el swal con el envío del email a operaciones
        /*                   this.translate
                        .get("search.search-booked.error-room-booked")
                        .subscribe((resp) => {
                          this.ngxToastrService.typeInfo(resp, err.error.message);
                        }); */
        const author = [this.externalUser?.name, this.externalUser?.lastname]
          .filter(Boolean)
          .join(" ")
          .trim();
        const body = {
          hotel: {
            name: hotel.name,
            totalRooms: searchConfig.occupancies.length,
            room: {
              adults: totalAdults,
              price:
                roomBooked.rates[0].totalWithPercentage ||
                `${roomBooked.rates[0].net}`,
              roomNumber: roomBookedIdx,
              roomName: roomBooked.name,
            },
            address: hotel.address,
          },
          guests: params.guests,
          totalPrice: this.totalPrice.toLocaleString("es-ES", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          }),
          cancellationPolicies: roomBooked.rates[0].cancellationPolicies[0]?.from,
          checkIn: moment(new Date(params.checkIn)).format(
            "DD/MM/YYYY"
          ),
          checkOut: moment(new Date(params.checkOut)).format(
            "DD/MM/YYYY"
          ),
          author: author || "No consta",
        };
        this.travelUtilsService.removeTravelLocalStorage();
        if (bookingInfo.customCode !== "") {
          body["customCode"] = bookingInfo.customCode;
        }
        if (bookingInfo.costCenter !== "") {
          body["costCenter"] = bookingInfo.costCenter;
        }
  
        if (bookingInfo.adminHotelComment !== "") {
          body["comments"] = bookingInfo.adminHotelComment;
        }
  
        if (
          selectedRooms[roomBookedIdx].rates[0].boardCode ==
          "BB"
        ) {
          body["breakfast"] = true;
        } else {
          body["breakfast"] = false;
        }
  
        if (
          selectedRooms[roomBookedIdx]?.rates[0]?.boardName
        ) {
          body["boardName"] =
            selectedRooms[roomBookedIdx].rates[0].boardName;
        }
  
        if (
          selectedRooms[roomBookedIdx].rates[0]
            .cancellationPolicies
        ) {
          body["cancellation"] = true;
          body["cancellationDate"] =
            selectedRooms[
              roomBookedIdx
            ].rates[0].cancellationPolicies[0]?.from;
        } else {
          body["cancellation"] = false;
        }
        if(this.projectData && this.projectData.selectedProject && this.projectData.selectedProject.uuid !== "none"){
          body["project"] = this.projectData.selectedProject.title || "";
        }
  
        this.utilsService.sendEmailOperations(
          LetItGoType.hotel,
          body,
          params.userUuid ? (Array.isArray(params.userUuid) ? params.userUuid[0] : params.userUuid) : null
        );
        this.translate
          .get(["common.congrat", "common.operations"])
          .subscribe((resultOperations) => {
            Swal.fire({
              position: "center",
              imageUrl:
                "../../../../../assets/img/svg/check-circle.svg",
              title: resultOperations["common.congrat"],
              text: resultOperations["common.operations"],
              showConfirmButton: false,
              timer: this.utilsService.letItGoTimer,
              timerProgressBar: true,
            }).then(() => {
              const route = this.utilsService.getNavigationRoute(this.externalUser, null, this.canUseTRM);
              if (route) {
                this.router.navigate([route], { queryParams: { specialAction: true } });
              }
            });
          });
        }
    }

    getCurrentOccupancyIndex(searchConfig, selectedOccupancy) {
    return searchConfig.occupancies.findIndex(
      (occupancy) => occupancy === selectedOccupancy
    );
  }

  getTotalPriorityPrice(): number {
    if (!this.selectedPriority || this.selectedPriority.length === 0) return 0;

    return this.selectedPriority.reduce((sum, prio) => {
      const refs = Array.isArray(prio?.pax_references) ? prio.pax_references : null;
      const idx  = Array.isArray(prio?.pax_index) ? prio.pax_index : null;

      const passengerCount = refs?.length ?? idx?.length ?? 1;
      return sum + (Number(prio?.total || 0) * passengerCount);
    }, 0);
  }

  private normalizePriorityForBooking(priority: any[]): any[] {
    if (!Array.isArray(priority)) return [];

    return priority
      .filter(p => p?.id)
      .map(p => {
        const enriched = this.enrichPriorityWithFlightInfo(p);

        return {
          ...enriched,
          pax_index: Array.isArray(enriched?.pax_index)
            ? enriched.pax_index.map((n: any) => Number(n)).filter((n: number) => !isNaN(n))
            : [],
          pax_references: Array.isArray(enriched?.pax_references)
            ? enriched.pax_references.map((x: any) => String(x))
            : []
        };
      });
  }

  private enrichBaggageWithFlightInfo(baggage: any): any {
    const segmentCode =
      baggage?.seg_references?.[0] ||
      baggage?.journey_references?.[0] ||
      "";

    const flightInfo = this.getFlightInfoBySegment(segmentCode);
    const legType = this.getLegTypeBySegment(segmentCode);

    return {
      ...baggage,
      segment: segmentCode || null,
      departure: flightInfo?.object?.departure ?? null,
      arrival: flightInfo?.object?.arrival ?? null,
      legType: legType || null,
    };
  }

  private enrichPriorityWithFlightInfo(priority: any): any {
    const segmentCode =
      priority?.seg_references?.[0] ||
      priority?.journey_references?.[0] ||
      "";

    const flightInfo = this.getFlightInfoBySegment(segmentCode);
    const legType = this.getLegTypeBySegment(segmentCode);

    return {
      ...priority,
      segment: segmentCode || null,
      departure: flightInfo?.object?.departure ?? null,
      arrival: flightInfo?.object?.arrival ?? null,
      legType: legType || null,
    };
  }

}
